// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:35:52.058Z
// Property: Evolv (ID: 5677123549265920)
// Collections: 16 amenities, 9 floorplans (live), 21 photos, 84 POIs, 1 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5677123549265920",
  "property_external_id": "4349312",
  "property_zillow_url": "https://www.zillow.com/homedetails/370-N-State-Highway-360-Mansfield-TX-76063/299038188_zpid/",
  "property_apartments_url": "https://www.apartments.com/evolv-mansfield-tx/6l1tdtv",
  "property_google_business_url": "https://www.google.com/maps/place/Evolv/@32.567481,-97.0814437,15z/data=!4m5!3m4!1s0x0:0xfb2f3f4eda5f9748!8m2!3d32.567481!4d-97.0814437",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443846699",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "evolv",
  "property_name": "Evolv",
  "property_website_url": "https://www.evolvmansfield.com/",
  "property_domain": "https://www.evolvmansfield.com/",
  "property_address": "370 N State Highway 360",
  "property_full_address": "370 N State Hwy 360, Mansfield, TX 76063",
  "property_address_1": "370 N State Hwy 360",
  "property_address_2": null,
  "property_address_city": "Mansfield",
  "property_address_state": "TX",
  "property_address_zip_full": "76063-9023",
  "property_address_zip": "76063",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "South Fort Worth",
  "property_address_latitude": "32.5657618",
  "property_address_longitude": "-97.07923770000001",
  "property_email": "evolv@alapts.com",
  "property_phone": "(817) 477-2787",
  "property_call_tracking_phone": "817-631-2040",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Contemporary Mansfield living with room to move.</strong> Evolv pairs open-concept one-, two-, and three-bedroom homes with granite countertops, stainless steel appliances, walk-in closets, and easy access to Highway 360—schedule your tour to see it in person.</p>",
  "property_long_description": "<p><strong>Contemporary Mansfield living with room to move.</strong> At Evolv, you’re connected to the best of South Fort Worth and Mansfield from a Highway 360 address near Broad Street shopping, dining, and daily essentials. Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with open-concept kitchens, granite countertops, stainless steel appliances, generous walk-in closets, wood-style plank flooring, and private patios or balconies in select homes.</p><p>Outside your door, <a href=\"/amenities\">resort-inspired amenities</a> make everyday living feel easy: a sparkling pool, clubhouse, business center, fitness spaces, outdoor kitchen with grilling stations, courtyards, package service, online resident services, and a Bark Park with pet washing station. When you want to get out, Historic Downtown Mansfield brings local dining, shopping, music, and art, while Walnut Creek Linear Trail, Elmer W. Oliver Nature Park, and nearby Joe Pool Lake put fresh-air escapes within reach. With quick access to SH 360, US 287, Arlington, Fort Worth, and Dallas, Evolv keeps your routine convenient—and your downtime close to home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-c334-7374-a29f-0e0acdab8924.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury swimming pool with lounge chairs and cabana at a multifamily property.",
    "public_id": "019e8996-c334-7374-a29f-0e0acdab8924",
    "storage_key": "property/5677123549265920/019e8996-c334-7374-a29f-0e0acdab8924.webp",
    "width": 3072,
    "height": 2051
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "334",
  "property_year_built": "2010",
  "property_year_renovated": "2018",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.311377245509",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nApplication Approval Fee Starting at $300\nNon-Refundable Pet Fee $250 / pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $250 per pet, refundable pet deposit of $250 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $250 per pet, refundable pet deposit of $250 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://6951342.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://evolv.loftliving.com/login",
  "property_apply_now_url": "https://6951342.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e6a8d-48c6-7312-b28c-d01cf7eec2cf.webp",
  "property_primary_logo_media": {
    "alt_text": "eVolv Apartment Homes logo",
    "public_id": "019e6a8d-48c6-7312-b28c-d01cf7eec2cf",
    "storage_key": "property/5677123549265920/019e6a8d-48c6-7312-b28c-d01cf7eec2cf.webp",
    "width": 1746,
    "height": 996
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019d02f0-e62a-763e-8ec7-95b02774eb5d.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f0-e62a-763e-8ec7-95b02774eb5d",
    "storage_key": "property/5677123549265920/019d02f0-e62a-763e-8ec7-95b02774eb5d.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e6a8d-48b4-753a-90d8-ea60089a7241.webp",
  "property_icon_media": {
    "alt_text": "Abstract logo with four overlapping, gradient-filled petal shapes in red, blue, and teal.",
    "public_id": "019e6a8d-48b4-753a-90d8-ea60089a7241",
    "storage_key": "property/5677123549265920/019e6a8d-48b4-753a-90d8-ea60089a7241.webp",
    "width": 782,
    "height": 782
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e6a8d-48b4-753a-90d8-ea60089a7241.webp",
  "property_fav_icon_media": {
    "alt_text": "Abstract logo with four overlapping, gradient-filled petal shapes in red, blue, and teal.",
    "public_id": "019e6a8d-48b4-753a-90d8-ea60089a7241",
    "storage_key": "property/5677123549265920/019e6a8d-48b4-753a-90d8-ea60089a7241.webp",
    "width": 782,
    "height": 782
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f4286-9fe9-7412-bb73-88c3093f97c6.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f4286-9fe9-7412-bb73-88c3093f97c6",
    "storage_key": "property/5677123549265920/019f4286-9fe9-7412-bb73-88c3093f97c6.webp",
    "width": 1280,
    "height": 730
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f4286-889c-74a2-b4af-c2f59f340ff8.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f4286-889c-74a2-b4af-c2f59f340ff8",
    "storage_key": "property/5677123549265920/019f4286-889c-74a2-b4af-c2f59f340ff8.webp",
    "width": 1280,
    "height": 730
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#ea4e3c",
  "property_secondary_color": "#000000",
  "property_font_color": "#2e2a25",
  "property_color_4": "#516185",
  "property_color_3": "#266474",
  "property_color_5": "#3a263e",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "751 - 1403",
  "property_sqft_min": "751",
  "property_sqft_max": "1403",
  "property_price_range": "1220 - 1853",
  "property_price_min": "1220",
  "property_price_max": "1853",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/EvolvApartments",
  "property_instagram_url": "https://www.instagram.com/evolvapartmenthomes",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJV4NY72KKToYRSJdf2k4_L_s",
  "property_youtube_url": "https://www.youtube.com/channel/UC0f8noGxepAXBXS8HvwqvBA",
  "property_yelp_url": "https://www.yelp.com/biz/evolv-apartment-homes-by-advenir-living-mansfield",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, polished up.</strong> At Evolv, resort-style relaxation, smart resident services, and pet-friendly perks come together in Mansfield. Recharge in the fitness center, lounge by the pool and outdoor kitchen, or streamline the day with package pickup and 24/7 online requests. Inside select homes, granite countertops, stainless steel appliances, wood-style plank flooring, walk-in closets, private outdoor space, and in-home washers and dryers add the details that make routines feel effortless.</p>",
  "property_home_floorplans_blurb": "<p><strong>One-, two-, and three-bedroom layouts make it easy to compare your options.</strong> At Evolv, floor plans pair open-concept kitchens with pantry storage, granite countertops, stainless steel appliances, wood-style plank flooring, high ceilings, and walk-in closets. Select homes add private patios or balconies, in-home washers and dryers, island kitchens, double vanities, and extra storage—details that help each space feel polished, practical, and ready to tour.</p>",
  "property_home_gallery_blurb": "<p><strong>See Evolv in focus.</strong> Preview granite-topped kitchens, stainless steel appliances, and island-style gathering space, then follow the view to select patios and balconies. The gallery also captures the bright fitness center, clubhouse seating, business center, poolside lounge, grilling areas, courtyard, and pet-friendly spaces that add everyday texture in Mansfield.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Close to Mansfield favorites, connected to the Metroplex.</strong> Evolv’s Highway 360 location puts East Broad Street shopping, coffee, brunch, and everyday stops within easy reach, with Historic Downtown Mansfield nearby for cafés, boutiques, murals, live music, and local events. For fresh air, explore Walnut Creek Linear Trail, Oliver Nature Park, or Joe Pool Lake—then branch out to Arlington, Grand Prairie, Fort Worth, or Dallas via major routes.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents are talking about Evolv.</strong> Reviews point to the details that make everyday living stand out: a modern apartment feel, well-kept grounds, quiet surroundings, and a pool that earns repeat praise.</p><p>The service gets noticed, too, with residents highlighting friendly communication, thoughtful move-in support, and a Mansfield location that keeps daily essentials close. Read the full reviews to see what makes Evolv feel cared for from the moment you arrive.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a day that stays close—or branches out fast.</strong> From Evolv’s Highway 360 setting, you’re positioned near East Broad Street conveniences, from Kroger-anchored Broad Street Commons to coffee, brunch, and quick bites, while Historic Downtown Mansfield adds porch-style cafés, boutiques, murals, live music, and community events with a more local pace. When you want fresh air, Walnut Creek Linear Trail connects parks, creek overlooks, picnic stops, and bike-friendly paths, with Oliver Nature Park and Joe Pool Lake nearby for bigger escapes. Arlington, Grand Prairie, Fort Worth, and Dallas are all reachable by major routes, so the neighborhood works just as well for errands, outings, and weekend plans. Explore the area on the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Evolv fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Ease is built into the details.</strong> At Evolv, your amenities support the moments between plans: pick up packages on your schedule, handle requests through 24/7 online resident services, refresh at the fitness center, or unwind by the resort-style pool and outdoor kitchen after a full day in Mansfield.</p><p>Inside, open-concept kitchens with granite countertops, stainless steel appliances, pantry storage, and wood-style plank flooring add everyday polish, while generous walk-in closets, private patios or balconies, and in-home washers and dryers in select homes keep routines streamlined. Four-legged companions get thoughtful perks too, with a Bark Park, pet play area, and pet washing station. Preview the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the community firsthand.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Evolv home?</strong> Start your application online for contemporary Mansfield living with open-concept floor plans, granite countertops, stainless steel appliances, walk-in closets, and easy access to Highway 360. With resort-inspired spaces and everyday conveniences close by, your next home is within reach.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Evolv leasing team to learn more about contemporary Mansfield apartments near Highway 360, explore available <a href=\"/floor-plans\">floor plans</a>, or get directions for your visit. Reach out today and let us help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at Evolv?</strong> Start here for quick answers on the community, leasing, apartment features, amenities, and everyday conveniences. If you don’t find what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> Evolv’s Mansfield apartment floor plans span comfortable one-bedroom homes, versatile two-bedroom layouts, and roomy three-bedroom residences, so you can compare options by bedroom count, availability, and price at a glance.</p><p>Inside, open-concept kitchens with pantry storage set an easy flow into the living area, while granite countertops, stainless steel appliances, wood-style plank flooring, high ceilings, walk-in closets, and private patios or balconies in select homes add polish where it counts. Select plans also offer in-home washers and dryers, double vanities, island kitchens, and extra storage. Browse the cards below, view the finishes in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture your day at Evolv.</strong> Browse the gallery for light-filled kitchens with granite surfaces, stainless steel appliances, and island-style gathering space, then look closer at living areas that open toward patios or balconies in select homes. The photos move from polished apartment interiors to the places that shape daily rhythm: the bright fitness center, relaxed clubhouse seating, business center, and poolside lounge.</p><p>Outdoors, see the courtyard, grilling areas, community exteriors, and pet-friendly spaces that bring texture to life in Mansfield. When a photo catches your eye, explore more <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Evolv on the map.</strong> See available apartments at a Highway 360 address near Broad Street shopping, dining, and daily essentials—then zoom out to discover Mansfield favorites, fresh-air escapes, and easy routes toward Arlington, Fort Worth, and Dallas.</p>",
  "property_pets_blurb": "<p><strong>Pet care feels easy here.</strong> At Evolv, cats and dogs are part of the daily rhythm, with convenient spaces designed around fresh air, quick cleanups, and extra wiggle room. Start with a stroll along the community’s walking and biking trails, let your pup burn energy at the Bark Park or pet play area, then stop by the pet washing station before heading back home.</p><p>Inside your apartment, wood-style plank flooring, generous closets, and private patios or balconies in select homes help make life with pets feel more practical. For longer outings, Mansfield’s local dog park options add even more ways to get outside. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Evolv fits your routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Evolv lifestyle.</strong> If open-concept homes, modern finishes, easy amenities, and a connected Mansfield location are what make Evolv feel right, invite a friend to experience it too. Send a referral today and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Evolv.</strong> Keep your routine easy with online resident services designed for everyday convenience. Log in to pay rent, submit maintenance requests, and manage your account—then get back to enjoying contemporary Mansfield living with the comfort and connection that make Evolv feel like home.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Evolv.</strong> In their own words, reviews highlight what stands out day to day: a modern apartment feel, a well-kept community, quiet surroundings, and a pool that gets plenty of love.</p><p>Residents also call out the team’s service again and again—from friendly greetings to move-in details that make a difference. One reviewer put it simply: <strong>“The service I have gotten is nothing short of amazing.”</strong> As you browse the reviews, you’ll find praise for the convenient Mansfield setting, helpful staff, and an apartment community that feels cared for from the moment you arrive.</p>",
  "property_created_at": "1752256481742",
  "property_scheduletour_blurb": "<p><strong>See Evolv up close.</strong> Tour open-concept one-, two-, and three-bedroom homes with granite countertops, stainless steel appliances, walk-in closets, wood-style flooring, and select private patios or balconies. Explore the spaces that make everyday living feel easy—then find the layout that fits your next move.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Evolv.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture contemporary Mansfield living with open-concept interiors, polished finishes, spacious closets, and easy access to resort-inspired spaces that keep everyday routines convenient and downtime close to home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Evolv’s virtual tours let you move through the spaces that matter most, from community tours to a bright Fitness Center with dedicated cardio, strength, and spin areas. Pause where you want, turn toward the windows, and get a feel for how the amenities flow without leaving your screen.</p><p>Inside the apartment tours, explore a one-bedroom layout and the B3 two-bedroom floor plan, looking closely at open-concept kitchens, granite surfaces, stainless steel appliances, island-style prep space, and the everyday storage that shapes how a home lives. When you’re ready to compare more options, browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Evolv in Mansfield in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Evolv",
  "property_seo_title_home": "Evolv | Apartments in Mansfield, TX",
  "property_seo_description_home": "Discover your dream living space at Evolv, an exceptional apartment community in Mansfield, TX. With a variety of floor plans, including one, two, and three-bedroom options, you’ll find the perfect home tailored to your lifestyle. Enjoy top-notch amenities like a fitness center, dog park, and a stunning pool with courtyard views. Benefit from online resident services and relax in your personal outdoor space. Don’t miss out – find your new home today at Evolv!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Mansfield, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Evolv in Mansfield, TX! Explore our diverse floor plans, including one, two, and three-bedroom apartments designed for comfort and style. Browse our available apartment homes today and find the perfect floor plan that fits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Mansfield, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your dream home at Evolv in Mansfield, TX! Choose from our spacious one, two, and three-bedroom floor plans, all featuring upscale amenities including a stunning dog park, modern business center, and a sparkling pool. Enjoy gourmet kitchens with included appliances, walk-in closets, and select homes with beautiful courtyard or golf course views. Plus, embrace a lifestyle of convenience with online resident services and a fully-equipped fitness center. Explore our amazing community amenities and find your perfect apartment today!",
  "property_seo_title_gallery": "Gallery | Apartments in Mansfield, TX",
  "property_seo_description_gallery": "Discover the perfect blend of comfort and convenience at Evolv Apartment Community in Mansfield, TX! Explore our stunning photo gallery showcasing stylish one, two, and three-bedroom floor plans. Enjoy exceptional amenities, including a dog park, fitness center, outdoor kitchen, and a refreshing pool. Picture yourself living here with gorgeous views, spacious walk-in closets, and modern kitchen appliances that elevate your lifestyle. Don’t miss out—experience the inviting community atmosphere and luxury amenities that await you at Evolv!",
  "property_seo_title_virtualtours": "Virtual Tours | Evolv Apartments",
  "property_seo_description_virtualtours": "\"Explore Evolv in Mansfield, TX! Discover our spacious one, two, and three-bedroom floor plans through an immersive virtual tour. Experience modern living and exceptional amenities today—take your virtual tour now!\"",
  "property_seo_title_interactivemap": "Interactive Map | Evolv Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Evolv Apartments in Mansfield, TX! Choose from a variety of spacious floor plans, including one, two, and three-bedroom options. Experience top-notch amenities such as a fitness center, dog park, and outdoor kitchen, plus convenient online resident services. Use our interactive community map to explore available apartments, discover pricing, and find your perfect home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mansfield, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood around Evolv in Mansfield, TX! Explore our stunning one, two, and three-bedroom floor plans and see what's nearby. From local favorites to essential points of interest, immerse yourself in the community that complements your lifestyle. Don’t miss out—check it out today!",
  "property_seo_title_contact": "Contact Us | Evolv",
  "property_seo_description_contact": "Looking for your perfect home in Mansfield, TX? Evolv offers a variety of stunning apartment floor plans including one, two, and three-bedroom options to fit your lifestyle. Have questions? Contact our leasing team today and discover what makes Evolv the ideal place to live!",
  "property_seo_title_faqs": "FAQs | Apartments in Mansfield, TX",
  "property_seo_description_faqs": "Discover the perfect home at Evolv in Mansfield, TX! Explore our variety of floor plans including one, two, and three-bedroom options. Enjoy top-notch amenities like a dog park, fitness center, and refreshing pool. Have questions? Browse our FAQs page to find answers about our vibrant community and exceptional services. Your ideal lifestyle awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mansfield, TX",
  "property_seo_description_reviews": "Discover why residents love calling Evolv home in Mansfield, TX! Explore our diverse floor plans—one, two, and three bedrooms—alongside top-notch amenities like a fitness center, dog park, and a stunning pool. Dive into online resident services, enjoy outdoor spaces, and experience the comfort of walk-in closets and yard options. Don’t just take our word for it; see what our residents have to say about living in our vibrant community! Join us at Evolv today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mansfield, TX",
  "property_seo_description_applynow": "Discover your perfect home at Evolv Apartments in Mansfield, TX! Choose from stunning one, two, or three-bedroom floor plans, all featuring top-notch amenities like a business center, fitness center, dog park, and a refreshing pool. Enjoy the convenience of online resident services, modern kitchen appliances, and spacious walk-in closets. With options for outdoor living, garage parking, and beautiful views, you’ll love every moment spent here. Ready to make the move? Find your new home and lease online today at Evolv!",
  "property_seo_title_residentaccess": "Resident Access | Evolv",
  "property_seo_description_residentaccess": "\"Welcome to Evolv in Mansfield, TX! Access your resident portal for seamless rent payments, hassle-free maintenance scheduling, and exclusive community updates. Join us today for a convenient living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Evolv",
  "property_seo_description_referafriend": "\"Great friends make great neighbors at Evolv in Mansfield, TX! Refer a friend to our vibrant apartment community today and unlock exclusive rewards. Join a neighborhood where connection and comfort thrive!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Evolv",
  "property_seo_description_scheduletour": "\"Discover your dream home at Evolv in Mansfield, TX! Schedule a tour today to explore our modern apartment community, exceptional amenities, and vibrant lifestyle. Don’t miss out on the chance to find your perfect living space!\"",
  "property_seo_title_privacy": "Privacy Policy | Evolv",
  "property_seo_description_privacy": "Discover how Evolv in Mansfield, TX, safeguards your personal information. Our comprehensive privacy policy outlines our commitment to transparency and security. View our privacy policy to learn more about how we protect your data.",
  "property_seo_title_accessibility": "Website Accessibility | Evolv",
  "property_seo_description_accessibility": "Discover Evolv in Mansfield, TX, where we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can explore our vibrant apartment community with ease. Join us in creating a welcoming environment—learn more about our accessibility features today!",
  "property_seo_title_sitemap": "Sitemap | Evolv",
  "property_seo_description_sitemap": "\"Explore Evolv, your premier apartment community in Mansfield, TX! Navigate through our comprehensive sitemap to easily discover floor plans, amenities, and more. Start your journey toward your new home today!\"",
  "property_seo_title_thankyou": "Thank You | Evolv",
  "property_seo_description_thankyou": "Thank you for reaching out to Evolv in Mansfield, TX! Your interest is important to us. One of our dedicated team members will contact you shortly to assist you in finding your perfect apartment home. Stay tuned for updates and exciting community news!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319809",
  "amenities": [
    {
      "id": "custom_46a824b7-8240-4fb7-a0a0-5038ee99d701",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d8dfc2fa-965f-4790-8592-5bb85e4003c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Resident Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfae88fd-40bc-4625-8938-c56a8f511fea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7923b7ca-1c4e-4700-9883-927dd4e11d78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eed5f7e3-fc4a-49b8-9a1a-5216b27995e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a732203-a132-4468-9b81-17944c8761a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood-Style Plank Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_872a3a4a-5976-42c7-aee5-d00337f3d369",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39da6d1d-8046-4b5a-8782-82f2e21f1454",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5142d493-6602-42ce-90bf-b9375b255719",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen w/ Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f7e190b-a13b-4982-99d4-810728fd82ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios or Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f16b1b7-c8dc-4c09-b46d-bdef6e1da7c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Open Concept Kitchen w/ Pantry Closets",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c02f423-3ffd-452c-b423-a681ca3aca10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Kid's Playscape",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5db65038-8f61-4afc-bab4-85091c78b2bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a25e6bc1-7266-47a2-b1ec-7a8b615abaf0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a96fb0ee-0712-4f76-986c-8e7f4f7fe362",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_877e695d-7095-413c-b0e7-e850ddbe0b8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_82614a08-27d1-42d2-83d8-686cb53e87eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-c334-7374-a29f-0e0acdab8924.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and cabana at a multifamily property.",
        "public_id": "019e8996-c334-7374-a29f-0e0acdab8924",
        "storage_key": "property/5677123549265920/019e8996-c334-7374-a29f-0e0acdab8924.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and cabana at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15fa4892-27fa-470c-87e4-eb83b3d62260",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-b108-7268-90ae-eadd05f80018.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with dark leather sofa, accent chairs, and coffee table, overlooking a pool area through large windows.",
        "public_id": "019e8996-b108-7268-90ae-eadd05f80018",
        "storage_key": "property/5677123549265920/019e8996-b108-7268-90ae-eadd05f80018.webp",
        "width": 3072,
        "height": 1761
      },
      "title": "Community",
      "description": "Relax and unwind in our modern lounge, featuring comfortable seating and stunning views of the resort-style pool.",
      "link": "",
      "alt_text": "Stylish lounge area with dark leather sofa, accent chairs, and coffee table, overlooking a pool area through large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e06acdc8-4bfd-4b6e-9d8f-a29f08ca689f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-aa44-75ed-ae13-f51ed7786b3d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and shaded seating areas.",
        "public_id": "019e8996-aa44-75ed-ae13-f51ed7786b3d",
        "storage_key": "property/5677123549265920/019e8996-aa44-75ed-ae13-f51ed7786b3d.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded cabanas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and shaded seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6748e057-be2b-4650-95a8-9a53c3bf0869",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-b36f-72a6-9713-980217603305.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area in an apartment with stainless steel appliances and granite countertops.",
        "public_id": "019e8996-b36f-72a6-9713-980217603305",
        "storage_key": "property/5677123549265920/019e8996-b36f-72a6-9713-980217603305.webp",
        "width": 2951,
        "height": 1717
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring granite countertops and stainless steel appliances, seamlessly opening into a spacious living and dining area.",
      "link": "",
      "alt_text": "Modern kitchen and living area in an apartment with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_879e8eb1-3f66-4b31-8589-30fceea1e41f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-aeb2-75b1-93f3-2b8f1b4e28a1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
        "public_id": "019e8996-aeb2-75b1-93f3-2b8f1b4e28a1",
        "storage_key": "property/5677123549265920/019e8996-aeb2-75b1-93f3-2b8f1b4e28a1.webp",
        "width": 2837,
        "height": 1878
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb15ddd6-760d-4976-b390-a3065338a5e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-abb7-7668-b3e4-f649947b8087.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019e8996-abb7-7668-b3e4-f649947b8087",
        "storage_key": "property/5677123549265920/019e8996-abb7-7668-b3e4-f649947b8087.webp",
        "width": 3072,
        "height": 1923
      },
      "title": "Apartment",
      "description": "Spacious and well-equipped kitchen featuring granite countertops, stainless steel appliances, ample cabinet space, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae0811b0-a855-4374-8e75-bdaa77d4a7d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-adf3-74e1-85ca-d8aefb74693a.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and cabanas at an apartment complex.",
        "public_id": "019e8996-adf3-74e1-85ca-d8aefb74693a",
        "storage_key": "property/5677123549265920/019e8996-adf3-74e1-85ca-d8aefb74693a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with comfortable lounge chairs and shaded cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and cabanas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97ea6160-3daa-4085-ba7f-3461eeefa8ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-af8b-754a-b39e-357a35d6c3c2.webp",
      "image_media": {
        "alt_text": "Gym with spin bikes, treadmills, ellipticals, and weight machines.",
        "public_id": "019e8996-af8b-754a-b39e-357a35d6c3c2",
        "storage_key": "property/5677123549265920/019e8996-af8b-754a-b39e-357a35d6c3c2.webp",
        "width": 3016,
        "height": 2007
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, and open space for workouts.",
      "link": "",
      "alt_text": "Gym with spin bikes, treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c784b04-6800-45a4-bdca-2bb0a7a33383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-afde-7510-bde8-a0a937461965.webp",
      "image_media": {
        "alt_text": "Modern bedroom with king-size bed, dresser, and ceiling fan.",
        "public_id": "019e8996-afde-7510-bde8-a0a937461965",
        "storage_key": "property/5677123549265920/019e8996-afde-7510-bde8-a0a937461965.webp",
        "width": 3016,
        "height": 2007
      },
      "title": "Apartment",
      "description": "Spacious and elegantly appointed bedroom featuring a comfortable king-size bed, a modern dresser with a large mirror, and a ceiling fan for added comfort. The room is decorated with contemporary artwork.",
      "link": "",
      "alt_text": "Modern bedroom with king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_afeaa763-a0c3-4a58-ad28-2cd0ce4a61f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-ab88-75ac-8fec-269c4f8d107a.webp",
      "image_media": {
        "alt_text": "Evolv Apartment Homes monument sign with landscaping.",
        "public_id": "019e8996-ab88-75ac-8fec-269c4f8d107a",
        "storage_key": "property/5677123549265920/019e8996-ab88-75ac-8fec-269c4f8d107a.webp",
        "width": 2945,
        "height": 1960
      },
      "title": "Community",
      "description": "Welcome to Evolv Apartment Homes, a community offering a great place to live.",
      "link": "",
      "alt_text": "Evolv Apartment Homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db2650e8-d541-4220-be5f-60e169dc3bf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-a0dc-707e-b3cd-f186709cb81a.webp",
      "image_media": {
        "alt_text": "Kitchenette with granite island and bar stools, brick accent wall, stainless steel appliances, and modern light fixtures.",
        "public_id": "019e8996-a0dc-707e-b3cd-f186709cb81a",
        "storage_key": "property/5677123549265920/019e8996-a0dc-707e-b3cd-f186709cb81a.webp",
        "width": 3017,
        "height": 2007
      },
      "title": "Community",
      "description": "Gather with friends in our stylish kitchenette, featuring a granite island, comfortable bar stools, and a fully equipped kitchen.",
      "link": "",
      "alt_text": "Kitchenette with granite island and bar stools, brick accent wall, stainless steel appliances, and modern light fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20991057-88ef-4e3c-b3bf-1b35f3f03a90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-9299-7123-b14d-cd0e6892585f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed and blue accents.",
        "public_id": "019e8996-9299-7123-b14d-cd0e6892585f",
        "storage_key": "property/5677123549265920/019e8996-9299-7123-b14d-cd0e6892585f.webp",
        "width": 2875,
        "height": 1910
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant decor, and a view into the en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed and blue accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4726fefe-0f0b-4f87-8057-8d1d35ffebb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-91e0-744a-9e9a-f950970db2c8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a large apartment building in the background.",
        "public_id": "019e8996-91e0-744a-9e9a-f950970db2c8",
        "storage_key": "property/5677123549265920/019e8996-91e0-744a-9e9a-f950970db2c8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge chairs and lush landscaping, it's the ideal spot to unwind after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a large apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c17e0adb-6e04-4b86-9cab-4fd75e39dd07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-9174-728b-9b6c-0f695b8cf632.webp",
      "image_media": {
        "alt_text": "Spin bikes and exercise balls in the apartment community gym.",
        "public_id": "019e8996-9174-728b-9b6c-0f695b8cf632",
        "storage_key": "property/5677123549265920/019e8996-9174-728b-9b6c-0f695b8cf632.webp",
        "width": 3016,
        "height": 2007
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio equipment and free weights for a complete workout.",
      "link": "",
      "alt_text": "Spin bikes and exercise balls in the apartment community gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42248903-2c5a-42b4-9b8e-48e9f92be88d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-916e-76bd-bac1-c8b0c6ae5fca.webp",
      "image_media": {
        "alt_text": "Billiard table and lounge area with blue chairs and televisions.",
        "public_id": "019e8996-916e-76bd-bac1-c8b0c6ae5fca",
        "storage_key": "property/5677123549265920/019e8996-916e-76bd-bac1-c8b0c6ae5fca.webp",
        "width": 3072,
        "height": 1990
      },
      "title": "Community",
      "description": "Enjoy recreational activities in the community's billiards room, complete with comfortable seating and entertainment options.",
      "link": "",
      "alt_text": "Billiard table and lounge area with blue chairs and televisions.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aadf87b2-e598-49b5-953e-210c2e2f03a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-9298-74a5-9587-20e777bfa003.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio equipment like treadmills, ellipticals, and stationary bikes.",
        "public_id": "019e8996-9298-74a5-9587-20e777bfa003",
        "storage_key": "property/5677123549265920/019e8996-9298-74a5-9587-20e777bfa003.webp",
        "width": 3020,
        "height": 1623
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with cardio equipment like treadmills, ellipticals, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d47e19d-3c97-4836-8dcb-f57536b4a950",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-92fa-71b3-81dc-aba52b7f4f61.webp",
      "image_media": {
        "alt_text": "Community lounge area with a large stone fireplace and comfortable seating.",
        "public_id": "019e8996-92fa-71b3-81dc-aba52b7f4f61",
        "storage_key": "property/5677123549265920/019e8996-92fa-71b3-81dc-aba52b7f4f61.webp",
        "width": 2657,
        "height": 1628
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a stunning stone fireplace and plush seating.",
      "link": "",
      "alt_text": "Community lounge area with a large stone fireplace and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfb9ac74-0776-4b01-88ef-fe80a2ca6015",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-91fc-704b-b49f-2146aa61ecaa.webp",
      "image_media": {
        "alt_text": "Exterior view of a three-story apartment building with stone and stucco facade and balconies, under a blue sky with clouds.",
        "public_id": "019e8996-91fc-704b-b49f-2146aa61ecaa",
        "storage_key": "property/5677123549265920/019e8996-91fc-704b-b49f-2146aa61ecaa.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience comfortable living in this beautiful apartment community, featuring a modern exterior design and well-maintained grounds. Enjoy the convenience of ample parking and nearby green spaces.",
      "link": "",
      "alt_text": "Exterior view of a three-story apartment building with stone and stucco facade and balconies, under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8bd872b-cbcb-420d-8672-b88f1d3e6f0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-9190-742f-b33b-4ac9eb3be8dd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, double vanity, and view into bedroom.",
        "public_id": "019e8996-9190-742f-b33b-4ac9eb3be8dd",
        "storage_key": "property/5677123549265920/019e8996-9190-742f-b33b-4ac9eb3be8dd.webp",
        "width": 3017,
        "height": 2007
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite countertop, ample storage, and a view into a well-appointed bedroom. Perfect for relaxation and convenience.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertop, double vanity, and view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f9adc58-e89f-4a98-af30-40502019ece1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-926f-77db-b1dd-6f1cb047189a.webp",
      "image_media": {
        "alt_text": "Business center with desks, chairs, printers, and a large table.",
        "public_id": "019e8996-926f-77db-b1dd-6f1cb047189a",
        "storage_key": "property/5677123549265920/019e8996-926f-77db-b1dd-6f1cb047189a.webp",
        "width": 3072,
        "height": 1903
      },
      "title": "Community",
      "description": "Work and study in our resident business center, equipped with computers, printers, and comfortable seating.",
      "link": "",
      "alt_text": "Business center with desks, chairs, printers, and a large table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2aacc8b2-7f1b-4130-8059-9ca38b1feab0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-8bde-76e9-80c4-81cc0fed6219.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with dining table and seating.",
        "public_id": "019e8996-8bde-76e9-80c4-81cc0fed6219",
        "storage_key": "property/5677123549265920/019e8996-8bde-76e9-80c4-81cc0fed6219.webp",
        "width": 2304,
        "height": 1513
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a modern kitchen, dining area, and comfortable living room seating. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with dining table and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_4b1e48957289adeca3c6b23e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3200 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7d6d-70e9-8b62-65d7a8b2c983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7d6d-70e9-8b62-65d7a8b2c983",
        "storage_key": "property/5677123549265920/019f1508-7d6d-70e9-8b62-65d7a8b2c983.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/broad-and-360?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6565930920954347234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.5744804",
      "poi_longitude": "-97.0851731",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-453-1056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV1iRHHCKToYR4r48g2LfHls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_f2e45e2baca64d035887f73a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "MOOYAH Burgers, Fries & Shakes",
      "poi_type": "Restaurants",
      "poi_address": "3300 E Broad St Ste 102, Mansfield, TX 76063, USA",
      "poi_short_description": "Counter-serve chain for custom burgers, including poultry & veggie versions, plus fries & shakes.",
      "poi_long_description": "Counter-serve chain for custom burgers, including poultry & veggie versions, plus fries & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7de3-77c4-b8fe-fb7ca79dee82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7de3-77c4-b8fe-fb7ca79dee82",
        "storage_key": "property/5677123549265920/019f1508-7de3-77c4-b8fe-fb7ca79dee82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mooyah.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=9757072879943241070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooyah-burgers-fries--shakes",
      "poi_latitude": "32.5738006",
      "poi_longitude": "-97.0848107",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 682-518-9380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7SDtqW-KToYRbk2d0BYWaIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_72259521c1bea06b4b8385d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Hat Creek Burger Company",
      "poi_type": "Restaurants",
      "poi_address": "3321 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Counter-serve joint doling out all-American eats plus beer, wine & shakes in a cool space.",
      "poi_long_description": "Counter-serve joint doling out all-American eats plus beer, wine & shakes in a cool space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-76d2-72dc-9a85-011303c0cd27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-76d2-72dc-9a85-011303c0cd27",
        "storage_key": "property/5677123549265920/019f1508-76d2-72dc-9a85-011303c0cd27.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hatcreekburgers.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=mansfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401799262694388017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hat-creek-burger-company",
      "poi_latitude": "32.5769239",
      "poi_longitude": "-97.082795",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-405-2979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6UDMiUKLToYRMbFt1p3meYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_05285bcb6b94b87d86b4f677",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Jakes Burgers and Beer",
      "poi_type": "Restaurants",
      "poi_address": "132, 3540 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Chain restaurant with a selection of draft beer serving burgers and other comfort food in a relaxed setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7541-779d-a0b7-37196e903362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7541-779d-a0b7-37196e903362",
        "storage_key": "property/5677123549265920/019f1508-7541-779d-a0b7-37196e903362.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "https://www.jakesburgersandbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=852347461365769291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jakes-burgers-and-beer",
      "poi_latitude": "32.5776171",
      "poi_longitude": "-97.0786277",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-439-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-htEG-KToYRS6TpC4Al1As",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_c9dd0253b08745114b1c8046",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "360 Brunch House - Mansfield",
      "poi_type": "Restaurants",
      "poi_address": "3550 E Broad St #120, Mansfield, TX 76063, USA",
      "poi_short_description": "Spacious restaurant offering omelets, pancakes, burgers & other comfort food for breakfast & lunch.",
      "poi_long_description": "Spacious restaurant offering omelets, pancakes, burgers & other comfort food for breakfast & lunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7453-77df-9031-76d3c2217d51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7453-77df-9031-76d3c2217d51",
        "storage_key": "property/5677123549265920/019f1508-7453-77df-9031-76d3c2217d51.webp",
        "width": 1221,
        "height": 818
      },
      "poi_business_url": "https://www.360brunchhousemansfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8804487151946040628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "360-brunch-house---mansfield",
      "poi_latitude": "32.5781157",
      "poi_longitude": "-97.07781",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-422-3381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cCx3BWLToYRNAU8oWrSL3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "ec_246d49847cecf42ad29420d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Our Place Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "915 W Debbie Ln, Mansfield, TX 76063, USA",
      "poi_short_description": "Country kitchen serving homestyle breakfast, lunch & fresh-baked pies in a bright, cozy setting.",
      "poi_long_description": "Country kitchen serving homestyle breakfast, lunch & fresh-baked pies in a bright, cozy setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7684-710f-ace2-be056c8a545c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7684-710f-ace2-be056c8a545c",
        "storage_key": "property/5677123549265920/019f1508-7684-710f-ace2-be056c8a545c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ourplacerestaurants.com/mansfield/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5597802717832779637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "our-place-restaurant",
      "poi_latitude": "32.5913182",
      "poi_longitude": "-97.156655",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-473-9996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM-yVMGhhToYRdZcj1-ljr00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_07be87eeceed2bcb5d6aa74d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Eggsquisite Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1530 E Debbie Ln, Mansfield, TX 76063, USA",
      "poi_short_description": "Restaurant for breakfast and lunch, serving staples such as chicken fried steak and eggs benedict, as well as burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-78c2-74bf-b900-da677e1bbd4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-78c2-74bf-b900-da677e1bbd4d",
        "storage_key": "property/5677123549265920/019f1508-78c2-74bf-b900-da677e1bbd4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eggsquisitecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904676975296477828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eggsquisite-cafe",
      "poi_latitude": "32.6055894",
      "poi_longitude": "-97.1133045",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-592-3315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJed3nv3phToYRhHoxawUzMDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "ec_57180c87c3eb1b9468153d8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Paris Baguette",
      "poi_type": "Restaurants",
      "poi_address": "2301 E Broad St Ste 101, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7491-752f-8efb-d32c2341892a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7491-752f-8efb-d32c2341892a",
        "storage_key": "property/5677123549265920/019f1508-7491-752f-8efb-d32c2341892a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://parisbaguette.com/locations/tx/mansfield/2301-east-broad-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=16022775265221173188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paris-baguette",
      "poi_latitude": "32.5702084",
      "poi_longitude": "-97.1019373",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-214-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71ym_B1hToYRxF9sHzZVXN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_a9b20e1533ca52c1a8dcca9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Cupbop - Korean BBQ in a Cup",
      "poi_type": "Restaurants",
      "poi_address": "2421 E Broad St Ste 111, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7804-74d9-9f4d-43c85693d8d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7804-74d9-9f4d-43c85693d8d7",
        "storage_key": "property/5677123549265920/019f1508-7804-74d9-9f4d-43c85693d8d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cupbop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2259076621078957493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cupbop---korean-bbq-in-a-cup",
      "poi_latitude": "32.5688842",
      "poi_longitude": "-97.0999623",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-623-1029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSDC1qdhToYRtQ3NvzfaWR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_17184e5f454f4f8833164bd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "AMMAN GRILL",
      "poi_type": "Restaurants",
      "poi_address": "1051 N State Hwy 360 Ste 107, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-7ad3-76cf-a4d1-9ceaebccbedb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-7ad3-76cf-a4d1-9ceaebccbedb",
        "storage_key": "property/5677123549265920/019f1508-7ad3-76cf-a4d1-9ceaebccbedb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ammangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18108195288688702777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amman-grill",
      "poi_latitude": "32.577465",
      "poi_longitude": "-97.0821685",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-225-2021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSNIUv6LToYROTWxeaw7Tfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_862e5ff61eda300ac6e94675",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Sushi Gio",
      "poi_type": "Restaurants",
      "poi_address": "701 E Debbie Ln Ste 125, Mansfield, TX 76063, USA",
      "poi_short_description": "Sushi and Japanese fare offered in small plates in a laid-back restaurant with a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8175-740d-a0e7-6af926a248e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8175-740d-a0e7-6af926a248e5",
        "storage_key": "property/5677123549265920/019f1508-8175-740d-a0e7-6af926a248e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sushigiotx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12404144743189402959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-gio",
      "poi_latitude": "32.6010588",
      "poi_longitude": "-97.1280882",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-405-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5LbbJRhToYRT1VViOxfJKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_463aab2d4c8e967d238612f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Akarii Revolving Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "3341 E Broad St #101, Mansfield, TX 76063, USA",
      "poi_short_description": "Conveyor belt eatery serving classic sushi dishes and sake cocktails, along with other Japanese staples like miso soup.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8292-775d-8a3a-d0c0e289fb6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8292-775d-8a3a-d0c0e289fb6f",
        "storage_key": "property/5677123549265920/019f1508-8292-775d-8a3a-d0c0e289fb6f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://akariirevolvingsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=475236433528692823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "akarii-revolving-sushi-bar",
      "poi_latitude": "32.5772666",
      "poi_longitude": "-97.0824584",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-473-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSrpVe-LToYRVyDNtARhmAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_dfd39fc40a58a8fa079fc717",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Fish City Grill",
      "poi_type": "Restaurants",
      "poi_address": "581 W Debbie Ln, Mansfield, TX 76063, USA",
      "poi_short_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_long_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8160-740c-b29a-8b0bd0460538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8160-740c-b29a-8b0bd0460538",
        "storage_key": "property/5677123549265920/019f1508-8160-740c-b29a-8b0bd0460538.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://fishcitygrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13018638981180734831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fish-city-grill",
      "poi_latitude": "32.5914413",
      "poi_longitude": "-97.151185",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-225-2094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWJcJG9hToYRb71UfC1_q7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_7c86c5aac7e370e3370db95e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "1770 U.S. 287 Frontage Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8419-776f-a7d4-7d4e4dc89a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8419-776f-a7d4-7d4e4dc89a28",
        "storage_key": "property/5677123549265920/019f1508-8419-776f-a7d4-7d4e4dc89a28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-mansfield/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3530535696093752895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "32.5960682",
      "poi_longitude": "-97.1445587",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 682-518-1680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYHMl-ZhToYRPy6BkIL7_jA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_2be5b4a2ee7a31079e8bad0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "El Primo's Mexican Grill & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "2300 Matlock Rd Ste 21, Mansfield, TX 76063, USA",
      "poi_short_description": "Relaxed cantina serving classic Mexican meals & margaritas in a stylish, contemporary setting.",
      "poi_long_description": "Relaxed cantina serving classic Mexican meals & margaritas in a stylish, contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-849c-7243-bd3e-8f205c548be9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-849c-7243-bd3e-8f205c548be9",
        "storage_key": "property/5677123549265920/019f1508-849c-7243-bd3e-8f205c548be9.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://elprimos.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13923485777157322896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-primos-mexican-grill--cantina",
      "poi_latitude": "32.5937589",
      "poi_longitude": "-97.1064146",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-225-4140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0N_ru9hToYRkHiqZosoOsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_2eb508fc765452bc4d08eace",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "3300 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-6733-728f-87b1-0b38c9e6ad0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6733-728f-87b1-0b38c9e6ad0d",
        "storage_key": "property/5677123549265920/019f1506-6733-728f-87b1-0b38c9e6ad0d.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/mansfield/broad-st/035/00594?cid=loc_03500594_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12863003501618625217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "32.5737193",
      "poi_longitude": "-97.0834297",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-435-5417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d62-77ab-9288-ccd218f55aa4",
        "storage_key": "property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0CKqW-KToYRwXqVmoiRgrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_60f4a128be31096cc2c8e48a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "1670 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-6735-75f6-ab97-ed26b4398a71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6735-75f6-ab97-ed26b4398a71",
        "storage_key": "property/5677123549265920/019f1506-6735-75f6-ab97-ed26b4398a71.webp",
        "width": 1170,
        "height": 820
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/mansfield/h-e-b-mansfield-750?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores&utm_content=mansfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=6555059768200979253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "32.567437",
      "poi_longitude": "-97.1143342",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 682-400-8756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d62-77ab-9288-ccd218f55aa4",
        "storage_key": "property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyfk8lGhhToYRNeMSBSFA-Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_007e62541470dec2298f64e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "3145 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Upscale grocer offering a wide-ranging variety of eats and goods from around the world.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-84ef-70cf-815d-d900b87fbde5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-84ef-70cf-815d-d900b87fbde5",
        "storage_key": "property/5677123549265920/019f1508-84ef-70cf-815d-d900b87fbde5.webp",
        "width": 601,
        "height": 400
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/mansfield/3145-e-broad-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8338807899017259757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "32.576301",
      "poi_longitude": "-97.0879736",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-453-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d62-77ab-9288-ccd218f55aa4",
        "storage_key": "property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3aIfTHeKToYR7Solb5pluXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8bfaf72435c9d76139c83a4a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "930 N Walnut Creek Dr Ste 800, Mansfield, TX 76063, USA",
      "poi_short_description": "Department store chain for groceries, clothing, housewares, electronics, furniture, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-867f-71fd-96bb-e0d70f53d2a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-867f-71fd-96bb-e0d70f53d2a1",
        "storage_key": "property/5677123549265920/019f1508-867f-71fd-96bb-e0d70f53d2a1.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/284-mansfield-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12034831390512159303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.5761597",
      "poi_longitude": "-97.1300488",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-473-1189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3a-720f-aadf-da338ab410e0",
        "storage_key": "property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJebGuIaRhToYRR5oy62JPBKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_22adda2d7b187b16dbae85f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1740 FM157, Mansfield, TX 76063, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-85c1-73ba-a6be-05377e173a42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-85c1-73ba-a6be-05377e173a42",
        "storage_key": "property/5677123549265920/019f1508-85c1-73ba-a6be-05377e173a42.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4911-mansfield-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=222938950478676047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "32.5938551",
      "poi_longitude": "-97.1482738",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-779-6047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3a-720f-aadf-da338ab410e0",
        "storage_key": "property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl5C_NWVhToYRT0DhVcsJGAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_7f52bb7b251a1546372ea2e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "980 Hwy N 287, Mansfield, TX 76063, USA",
      "poi_short_description": "Well-stocked, clean supermarket chain with fresh produce, a bakery and a deli.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-887d-741e-a21e-4e3cec572616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-887d-741e-a21e-4e3cec572616",
        "storage_key": "property/5677123549265920/019f1508-887d-741e-a21e-4e3cec572616.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://local.tomthumb.com/tx/mansfield/980-hwy-n-287.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4221341232269345241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "32.5824481",
      "poi_longitude": "-97.1288556",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-453-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d62-77ab-9288-ccd218f55aa4",
        "storage_key": "property/5677123549265920/019f1506-9d62-77ab-9288-ccd218f55aa4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqz1-zKFhToYR2cEfMXw3lTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_4d3a3d87eeffa5bd05f152f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3802 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-873e-706a-9147-6c0687048051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-873e-706a-9147-6c0687048051",
        "storage_key": "property/5677123549265920/019f1508-873e-706a-9147-6c0687048051.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mansfield-tx-pharmacies/3802-east-broad-st-mansfield-tx-76063/storeid=10576?WT.mc_id=LS_GOOGLE_RX_10576",
      "poi_directions_map_url": "https://maps.google.com/?cid=15323990088586250152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.5793388",
      "poi_longitude": "-97.0743527",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-473-1373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2009-75d4-8da2-3fddc77819e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2009-75d4-8da2-3fddc77819e5",
        "storage_key": "property/5677123549265920/019f1509-2009-75d4-8da2-3fddc77819e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cc-CWmKToYRqEfKq8u_qdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_68d2a232850b556d10f042ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2901 E Broad St Walgreens, Mansfield, TX 76063, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-882c-74ff-843e-2c6e2a2d5f19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-882c-74ff-843e-2c6e2a2d5f19",
        "storage_key": "property/5677123549265920/019f1508-882c-74ff-843e-2c6e2a2d5f19.webp",
        "width": 1280,
        "height": 517
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2901+e+broad+st-mansfield-tx-76063/id=10872",
      "poi_directions_map_url": "https://maps.google.com/?cid=5789543892810337079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.5715448",
      "poi_longitude": "-97.093266",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-518-7219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWz4aLNZhToYRNwt-Bn-XWFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_161e53f9b5e0a56fbc4dcd63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "3801 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-89f9-75fd-977c-12169dd706ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-89f9-75fd-977c-12169dd706ac",
        "storage_key": "property/5677123549265920/019f1508-89f9-75fd-977c-12169dd706ac.webp",
        "width": 1280,
        "height": 746
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/mansfield/3801-e-broad-st-34044?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13721206186231603419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.5804346",
      "poi_longitude": "-97.0750344",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 682-518-8662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2063-7231-8385-0795a7f80c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2063-7231-8385-0795a7f80c80",
        "storage_key": "property/5677123549265920/019f1509-2063-7231-8385-0795a7f80c80.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJdQYqdGmKToYR2yA6DFSEa74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_d14c34cd993cbf431c61e05c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 U.S. 287 Frontage Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8a32-714e-8f5a-c1e4755bf4c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8a32-714e-8f5a-c1e4755bf4c9",
        "storage_key": "property/5677123549265920/019f1508-8a32-714e-8f5a-c1e4755bf4c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/mansfield/1536",
      "poi_directions_map_url": "https://maps.google.com/?cid=7574738899578349579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.5897903",
      "poi_longitude": "-97.144638",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-453-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3a-720f-aadf-da338ab410e0",
        "storage_key": "property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxc4XonFhToYRC2izf-XgHmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2564dbac694809e4e008d797",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mary Jo Sheppard Elementary",
      "poi_type": "Education",
      "poi_address": "1701 FM1187, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8a76-71bb-b195-878de1132742.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8a76-71bb-b195-878de1132742",
        "storage_key": "property/5677123549265920/019f1508-8a76-71bb-b195-878de1132742.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sheppard.mansfieldisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11549085450306505975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-jo-sheppard-elementary",
      "poi_latitude": "32.5862083",
      "poi_longitude": "-97.1688878",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-299-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP0mzokhhToYR98wmAgeYRqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_eae8581c38ae36b99cf97527",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Xplor Preschool of Mansfield",
      "poi_type": "Education",
      "poi_address": "300 N Holland Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8ea6-74f2-83e0-49511a1c252f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8ea6-74f2-83e0-49511a1c252f",
        "storage_key": "property/5677123549265920/019f1508-8ea6-74f2-83e0-49511a1c252f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.xplorpreschool.com/preschools/tx/dallas/mansfield/?utm_medium=directory&utm_source=gmb&utm_campaign=profile&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1788307677756742024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xplor-preschool-of-mansfield",
      "poi_latitude": "32.5678363",
      "poi_longitude": "-97.0667267",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-243-8066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrTg3FlyKToYRiFnLqVtY0Rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_e6b56d482be4131c1378710b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Primrose School of Walnut Creek",
      "poi_type": "Education",
      "poi_address": "2201 Matlock Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8bef-714c-ab2a-36b04823650d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8bef-714c-ab2a-36b04823650d",
        "storage_key": "property/5677123549265920/019f1508-8bef-714c-ab2a-36b04823650d.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/walnut-creek/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17201390754367125046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-walnut-creek",
      "poi_latitude": "32.595394",
      "poi_longitude": "-97.108896",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-477-0880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB-cOCO5hToYRNra9FMGdt-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_d1bd3875b336f804c708c6b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Linda Jobe Middle School",
      "poi_type": "Education",
      "poi_address": "2491 Gertie Barrett Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8d21-7401-b5e7-d7ab8af26438.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8d21-7401-b5e7-d7ab8af26438",
        "storage_key": "property/5677123549265920/019f1508-8d21-7401-b5e7-d7ab8af26438.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://jobe.mansfieldisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8572239066446490845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linda-jobe-middle-school",
      "poi_latitude": "32.6002418",
      "poi_longitude": "-97.1764786",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 682-314-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6dh-dlVhToYR3exEZQO29nY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a4feaaaafd301712e01eb1d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Lake Ridge High School",
      "poi_type": "Education",
      "poi_address": "101 Day Miar Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8fe4-74b4-bca7-1c956491163e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8fe4-74b4-bca7-1c956491163e",
        "storage_key": "property/5677123549265920/019f1508-8fe4-74b4-bca7-1c956491163e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lakeridge.mansfieldisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15678478639755539027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-ridge-high-school",
      "poi_latitude": "32.5716371",
      "poi_longitude": "-97.0554289",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 682-314-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNdLYpVaKToYRU7ItNUElldk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_26404a0f9822600cde97d0f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mansfield High School",
      "poi_type": "Education",
      "poi_address": "3001 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8d86-74b1-b93a-fb4c904347bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8d86-74b1-b93a-fb4c904347bb",
        "storage_key": "property/5677123549265920/019f1508-8d86-74b1-b93a-fb4c904347bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mansfield.mansfieldisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751710211680915791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-high-school",
      "poi_latitude": "32.5742794",
      "poi_longitude": "-97.0907289",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-314-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFULp6neKToYRT1FyY4_AEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a8195758b679b02a9bf68035",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "The Children's Courtyard of Mansfield",
      "poi_type": "Education",
      "poi_address": "3701 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Chain facility providing day care and summer camp services for infants, toddlers, and preschool-age children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-8f7d-73b0-bd49-aec6d2c4dc66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-8f7d-73b0-bd49-aec6d2c4dc66",
        "storage_key": "property/5677123549265920/019f1508-8f7d-73b0-bd49-aec6d2c4dc66.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://www.childrenscourtyard.com/your-local-school/mansfield-tx-3020/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=3020",
      "poi_directions_map_url": "https://maps.google.com/?cid=11212696438185828456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-courtyard-of-mansfield",
      "poi_latitude": "32.5798572",
      "poi_longitude": "-97.0764992",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 866-561-3412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsRKBSmmKToYRaKBazACAm5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_5bb92c85cb378f6015f121f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Skyrise School of Mansfield",
      "poi_type": "Education",
      "poi_address": "2120 Man Ave, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-91c4-766c-9d48-415295733034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-91c4-766c-9d48-415295733034",
        "storage_key": "property/5677123549265920/019f1508-91c4-766c-9d48-415295733034.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.skyriseschool.com/our-schools/mansfield/tx/000511?utm_campaign=sky-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MjAxMTc0NTQxNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5699735332811169334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyrise-school-of-mansfield",
      "poi_latitude": "32.596942",
      "poi_longitude": "-97.107503",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-453-3844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ54RwULNj5IkRNt7zMRaHGU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_a070d9832034ea70e19a8363",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Tarrant County College - Southeast Campus",
      "poi_type": "Education",
      "poi_address": "2100 Southeast Pkwy, Arlington, TX 76018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-7541-77af-a860-2a84d0407ac4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-7541-77af-a860-2a84d0407ac4",
        "storage_key": "property/5677123549265920/019f1506-7541-77af-a860-2a84d0407ac4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tccd.edu/locations/southeast-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8183517100702543187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---southeast-campus",
      "poi_latitude": "32.638997",
      "poi_longitude": "-97.071834",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSRqYQ8aJToYRU6216HGxkXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f22e94d137fb2751f5bde4ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Timberview High School",
      "poi_type": "Education",
      "poi_address": "7700 S Watson Rd, Arlington, TX 76002, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-9492-77e3-a29d-05e08422801b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-9492-77e3-a29d-05e08422801b",
        "storage_key": "property/5677123549265920/019f1508-9492-77e3-a29d-05e08422801b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://timberview.mansfieldisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7506947722149290440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timberview-high-school",
      "poi_latitude": "32.6215638",
      "poi_longitude": "-97.0759464",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-314-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRd0vQO6JToYRyOEiBi4JLmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_4ac68018580d07fe21d45d73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Flix Brewhouse - Mansfield",
      "poi_type": "Entertainment",
      "poi_address": "416 U.S. 287 Frontage Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Modern cinema with tilting seats plus craft beer and a food menu delivered to your seat.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-9182-7761-9d89-8ff6e87bc5b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-9182-7761-9d89-8ff6e87bc5b5",
        "storage_key": "property/5677123549265920/019f1508-9182-7761-9d89-8ff6e87bc5b5.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://flixbrewhouse.com/theaters/x11ng-flix-brewhouse-mansfield/?utm_source=google&utm_medium=organic&utm_campaign=gbp_location&utm_content=%3Ccity%3E",
      "poi_directions_map_url": "https://maps.google.com/?cid=17729647722913699327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flix-brewhouse---mansfield",
      "poi_latitude": "32.5716714",
      "poi_longitude": "-97.1157696",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 682-877-8001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-20d8-7678-baa5-8aa0ebf3f23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-20d8-7678-baa5-8aa0ebf3f23c",
        "storage_key": "property/5677123549265920/019f1509-20d8-7678-baa5-8aa0ebf3f23c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8yanrZhToYR_5UVFatcDPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_89209672949d5339d0944762",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Cinemark Mansfield and XD",
      "poi_type": "Entertainment",
      "poi_address": "2041 U.S. 287 Frontage Rd Ste 901, Mansfield, TX 76063, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-9939-77dc-970c-3197315bc780.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-9939-77dc-970c-3197315bc780",
        "storage_key": "property/5677123549265920/019f1508-9939-77dc-970c-3197315bc780.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-mansfield/cinemark-mansfield-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI4OTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7568663241937109965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-mansfield-and-xd",
      "poi_latitude": "32.599005",
      "poi_longitude": "-97.15075",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-473-6979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-20d8-7678-baa5-8aa0ebf3f23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-20d8-7678-baa5-8aa0ebf3f23c",
        "storage_key": "property/5677123549265920/019f1509-20d8-7678-baa5-8aa0ebf3f23c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJO2F0TGRhToYRzcM3OB5LCWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_675fe28e1a5690890316e94a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Farr Best Theater",
      "poi_type": "Entertainment",
      "poi_address": "109 N Main St, Mansfield, TX 76063, USA",
      "poi_short_description": "Restored 1917 theater presenting movies, music, theater & more  in an intimate, 158-seat venue.",
      "poi_long_description": "Restored 1917 theater presenting movies, music, theater & more  in an intimate, 158-seat venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-99f8-705c-a113-4eee1e8ff583.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-99f8-705c-a113-4eee1e8ff583",
        "storage_key": "property/5677123549265920/019f1508-99f8-705c-a113-4eee1e8ff583.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.mansfieldtexasarts.org/farr-best-theater",
      "poi_directions_map_url": "https://maps.google.com/?cid=2494272716533606048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farr-best-theater",
      "poi_latitude": "32.5639038",
      "poi_longitude": "-97.1421388",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-728-3339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwejXzgNhToYRoCbvCdJvnSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_bd5b625b5dcba26ab8d07f94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "989 N Walnut Creek Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-6faa-70e7-9622-c3a63d56a873.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6faa-70e7-9622-c3a63d56a873",
        "storage_key": "property/5677123549265920/019f1506-6faa-70e7-9622-c3a63d56a873.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-mansfield/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729129627808066694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.5788904",
      "poi_longitude": "-97.1342988",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 682-232-1709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdArDqFhToYRhmzigqOHwDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_ec78c62f8257ac863b7a5fad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Play Street Museum - Mansfield",
      "poi_type": "Entertainment",
      "poi_address": "110 U.S. 287 Frontage Rd Ste 118, Mansfield, TX 76063, USA",
      "poi_short_description": "Treehouse-equipped museum and play area for kids 0-8, also offering parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-765a-71ab-a6a7-87b84c36845b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-765a-71ab-a6a7-87b84c36845b",
        "storage_key": "property/5677123549265920/019f1506-765a-71ab-a6a7-87b84c36845b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://mansfield.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14006898478649786434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "play-street-museum---mansfield",
      "poi_latitude": "32.5660249",
      "poi_longitude": "-97.1187399",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-672-2988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3c-740d-92c1-6bcdeefbe859.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3c-740d-92c1-6bcdeefbe859",
        "storage_key": "property/5677123549265920/019f1506-9d3c-740d-92c1-6bcdeefbe859.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJW3ifuxphToYRQkDhYPR_YsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_6cef7e7409233fa565ebb739",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Hawaiian Falls Mansfield",
      "poi_type": "Entertainment",
      "poi_address": "490 Heritage Pkwy, Mansfield, TX 76063, USA",
      "poi_short_description": "Seasonal waterpark featuring slides, rides, wave pool & a lazy river, plus kids' play areas.",
      "poi_long_description": "Seasonal waterpark featuring slides, rides, wave pool & a lazy river, plus kids' play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-700b-774d-b425-c4fdf3a89b0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-700b-774d-b425-c4fdf3a89b0b",
        "storage_key": "property/5677123549265920/019f1506-700b-774d-b425-c4fdf3a89b0b.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://hfalls.com/mansfield.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=3748811012390014779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawaiian-falls-mansfield",
      "poi_latitude": "32.55726",
      "poi_longitude": "-97.083395",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-853-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4RS9HIaKToYRO0-U88BzBjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_73587247f75d9c8d4b7d23ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Henry's Cigar Lounge",
      "poi_type": "Entertainment",
      "poi_address": "101 S Main St, Mansfield, TX 76063, USA",
      "poi_short_description": "Relaxed lounge for cigars as well as drinks and food, plus TVS and comfy seating options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-99f7-7788-a094-317e1c617c3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-99f7-7788-a094-317e1c617c3e",
        "storage_key": "property/5677123549265920/019f1508-99f7-7788-a094-317e1c617c3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://henryscigarlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18105396851969596518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henrys-cigar-lounge",
      "poi_latitude": "32.5631236",
      "poi_longitude": "-97.1418698",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-225-2703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3a-720f-aadf-da338ab410e0",
        "storage_key": "property/5677123549265920/019f1506-9d3a-720f-aadf-da338ab410e0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUXCv535hToYRZpwfp4JKQ_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_039aaae58ad46e4041046d3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Vault Seafood & Steakhouse",
      "poi_type": "Entertainment",
      "poi_address": "2300 Matlock Rd #4, Mansfield, TX 76063, USA",
      "poi_short_description": "Upscale steakhouse specializing in steaks and seafood, plus cocktails and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-6773-7768-9c0c-0fafe1fda11a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-6773-7768-9c0c-0fafe1fda11a",
        "storage_key": "property/5677123549265920/019f1506-6773-7768-9c0c-0fafe1fda11a.webp",
        "width": 926,
        "height": 617
      },
      "poi_business_url": "https://www.thevaultmansfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10283652041549858265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vault-seafood--steakhouse",
      "poi_latitude": "32.5940214",
      "poi_longitude": "-97.1060596",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-512-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eE9eUhhToYR2cVM8gvfto4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_560b0d5aabda279c263e9811",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Fat Daddy's Sports & Spirits Cafe",
      "poi_type": "Entertainment",
      "poi_address": "781 W Debbie Ln, Mansfield, TX 76063, USA",
      "poi_short_description": "Beer & pub fare in a sports bar setting with many TVs, pool tables & live music.",
      "poi_long_description": "Beer & pub fare in a sports bar setting with many TVs, pool tables & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-98a9-720c-91c4-9cdd05867119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-98a9-720c-91c4-9cdd05867119",
        "storage_key": "property/5677123549265920/019f1508-98a9-720c-91c4-9cdd05867119.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://fatdaddyslive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12791556768502668289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fat-daddys-sports--spirits-cafe",
      "poi_latitude": "32.591192",
      "poi_longitude": "-97.154697",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-453-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2064-75fa-9c4d-0a87d5a01b73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2064-75fa-9c4d-0a87d5a01b73",
        "storage_key": "property/5677123549265920/019f1509-2064-75fa-9c4d-0a87d5a01b73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82ZcVmhhToYRAVzYvhu9hLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_7d7a36c6b536eb74e409cbdf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Big Fellas Ice House",
      "poi_type": "Entertainment",
      "poi_address": "1826 Cannon Dr Ste 100, Mansfield, TX 76063, USA",
      "poi_short_description": "Sports bar with burgers, wings, chicken sandwiches and live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-9e5f-712c-91f5-b9693b503295.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-9e5f-712c-91f5-b9693b503295",
        "storage_key": "property/5677123549265920/019f1508-9e5f-712c-91f5-b9693b503295.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bigfellasicehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7181165783257961275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-fellas-ice-house",
      "poi_latitude": "32.5727951",
      "poi_longitude": "-97.1081715",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-799-3376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d41-74b7-8818-1047a6652b5b",
        "storage_key": "property/5677123549265920/019f1506-9d41-74b7-8818-1047a6652b5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ37alRSNhToYRO9NHgDugqGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_770683f255a4f893266590bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Texas Health Hospital Mansfield",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 Lone Star Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-8c2c-7178-ae0d-831be2cb2890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-8c2c-7178-ae0d-831be2cb2890",
        "storage_key": "property/5677123549265920/019f1506-8c2c-7178-ae0d-831be2cb2890.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.texashealthmansfield.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6266422286248126131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-hospital-mansfield",
      "poi_latitude": "32.5370605",
      "poi_longitude": "-97.0996562",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 682-341-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3c-740d-92c1-6c4d64a18d3f",
        "storage_key": "property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZY-2MWBhToYRsyZpUN7N9lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_93c9b784fd9c8f3303338d66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Methodist Mansfield Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-85aa-76bf-acf4-a7da0138de15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-85aa-76bf-acf4-a7da0138de15",
        "storage_key": "property/5677123549265920/019f1506-85aa-76bf-acf4-a7da0138de15.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.methodisthealthsystem.org/methodist-mansfield-medical-center/?L=true",
      "poi_directions_map_url": "https://maps.google.com/?cid=14677445230321326988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-mansfield-medical-center",
      "poi_latitude": "32.5680233",
      "poi_longitude": "-97.0945881",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 682-242-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3c-740d-92c1-6c4d64a18d3f",
        "storage_key": "property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48CMNNRhToYRjNuNK6zCsMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_16a5c7b967c3e45df3769105",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - South Mansfield",
      "poi_type": "Health and Wellness",
      "poi_address": "3020 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-a03f-7534-82dd-c26878628a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a03f-7534-82dd-c26878628a3d",
        "storage_key": "property/5677123549265920/019f1508-a03f-7534-82dd-c26878628a3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/south-mansfield?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18369004027771736751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---south-mansfield",
      "poi_latitude": "32.5723166",
      "poi_longitude": "-97.0895364",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-453-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyROPATeLToYRr9INEdfP6_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_0901d941346366eec2408933",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Texas Health Breeze Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "111 W Debbie Ln Ste 101, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-9d2f-738a-9b4d-3b425ded03d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-9d2f-738a-9b4d-3b425ded03d7",
        "storage_key": "property/5677123549265920/019f1508-9d2f-738a-9b4d-3b425ded03d7.webp",
        "width": 548,
        "height": 308
      },
      "poi_business_url": "https://breeze.care.texashealth.org/Locations/urgent-care-debbie-mansfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=7663380934585877464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-breeze-urgent-care",
      "poi_latitude": "32.5927799",
      "poi_longitude": "-97.145451",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 682-212-9148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1YP61phToYR2AN-kFvMWWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e6abcd1061ae4e0cea56016c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 U.S. 287 Frontage Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-a23d-7407-9dba-57172722bff5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a23d-7407-9dba-57172722bff5",
        "storage_key": "property/5677123549265920/019f1508-a23d-7407-9dba-57172722bff5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mansfield-tx-pharmacies/1801-highway-287-n-mansfield-tx-76063/storeid=16866?WT.mc_id=LS_GOOGLE_RX_16866",
      "poi_directions_map_url": "https://maps.google.com/?cid=7671042074614924060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.5893807",
      "poi_longitude": "-97.1448562",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-453-0259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2009-75d4-8da2-3fddc77819e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2009-75d4-8da2-3fddc77819e5",
        "storage_key": "property/5677123549265920/019f1509-2009-75d4-8da2-3fddc77819e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxc4XonFhToYRHIN_uh8EdWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_21a3f3b9aa5016ec8e40bc91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "750 N Walnut Creek Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-a29e-764c-af78-245f52cab890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a29e-764c-af78-245f52cab890",
        "storage_key": "property/5677123549265920/019f1508-a29e-764c-af78-245f52cab890.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-750+n+walnut+creek+dr-mansfield-tx-76063/id=5213",
      "poi_directions_map_url": "https://maps.google.com/?cid=5202941999233676906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.5752008",
      "poi_longitude": "-97.1324747",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-477-5271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2009-75d4-8da2-3fddc77819e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2009-75d4-8da2-3fddc77819e5",
        "storage_key": "property/5677123549265920/019f1509-2009-75d4-8da2-3fddc77819e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSDo96ZhToYRarZIky6QNEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0d5041d03e54cfc8b97bfdb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "U.S. 287 Frontage Rd Suite 701, Mansfield, TX 76063, USA",
      "poi_short_description": "Well-kept gym with clean equipment, plus smith machines and a 24-hour schedule.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-7b1f-760d-8b39-436ee6c3afc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-7b1f-760d-8b39-436ee6c3afc7",
        "storage_key": "property/5677123549265920/019f1506-7b1f-760d-8b39-436ee6c3afc7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/mansfield-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1631462720468282700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.58688",
      "poi_longitude": "-97.140969",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-405-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2w8hbC5hToYRTO3NTbMepBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_942d4b4e9e7836297eb0ab55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mansfield YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "78 Regency Pkwy, Mansfield, TX 76063, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-7fb1-7497-b5cd-8f7531284e99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-7fb1-7497-b5cd-8f7531284e99",
        "storage_key": "property/5677123549265920/019f1506-7fb1-7497-b5cd-8f7531284e99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://amaymca.org/locations/mansfield-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10937771780223560525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-ymca",
      "poi_latitude": "32.5626416",
      "poi_longitude": "-97.1041021",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-612-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2lrlC1hToYRTWuEunvFypc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2a5e463cf7d7e1242687e329",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3141 E Broad St #221, Mansfield, TX 76063, USA",
      "poi_short_description": "Fitness chain offering a group workout that combines cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-8731-766b-a161-d9674aec17d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-8731-766b-a161-d9674aec17d2",
        "storage_key": "property/5677123549265920/019f1506-8731-766b-a161-d9674aec17d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/mansfield-texas-1056?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=3128923671239544768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "32.5753373",
      "poi_longitude": "-97.0889651",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-225-4104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfSdQUrOLToYRwE-LUYArbCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4614272583fe7cd122a1d32f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 E Debbie Ln, Mansfield, TX 76063, USA",
      "poi_short_description": "Fitness center offering classes in barre, Pilates and ballet, as well as low-impact options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-a8f3-76f8-a31c-9165ff497a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a8f3-76f8-a31c-9165ff497a63",
        "storage_key": "property/5677123549265920/019f1508-a8f3-76f8-a31c-9165ff497a63.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.purebarre.com/location/mansfield-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16109611152184897879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "32.6070642",
      "poi_longitude": "-97.1182927",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-385-9264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTdUIA3pjToYRV_Gmk_3VkN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_3ab132c02ccae9319476013d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Elmer W. Oliver Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1650 Matlock Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Wild expanse with trails, kayaking & fishing, bird blinds & an amphitheater, plus nature classes.",
      "poi_long_description": "Wild expanse with trails, kayaking & fishing, bird blinds & an amphitheater, plus nature classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-921a-730d-a778-34d8fc0c4fb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-921a-730d-a778-34d8fc0c4fb1",
        "storage_key": "property/5677123549265920/019f1506-921a-730d-a778-34d8fc0c4fb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://olivernaturepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18429290823861586052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elmer-w-oliver-nature-park",
      "poi_latitude": "32.5865342",
      "poi_longitude": "-97.1029786",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqW7P6-hhToYRhMiimlz-wf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2d0a07ea0503c78dfdae12c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Clayton W Chandler Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1530 N Walnut Creek Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "Clean, family-friendly space with baseball, tennis, soccer and football fields.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-b0b1-7080-ba60-e0d5087f6af4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b0b1-7080-ba60-e0d5087f6af4",
        "storage_key": "property/5677123549265920/019f1508-b0b1-7080-ba60-e0d5087f6af4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1113/Clayton-W-Chandler-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16828138368007733264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clayton-w-chandler-park",
      "poi_latitude": "32.5961504",
      "poi_longitude": "-97.129991",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbmeuIRhToYREAA5uK-Oiek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_43588f5218cbe8f3fcf21fd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Katherine Rose Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "303 N Walnut Creek Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "This park along a creek offers a lighted path, sports courts, picnic pavilions & a rose garden.",
      "poi_long_description": "This park along a creek offers a lighted path, sports courts, picnic pavilions & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-b75e-75b5-8c07-1b4d405b0c97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b75e-75b5-8c07-1b4d405b0c97",
        "storage_key": "property/5677123549265920/019f1508-b75e-75b5-8c07-1b4d405b0c97.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1095/Katherine-Rose-Memorial-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=544892829257759852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katherine-rose-memorial-park",
      "poi_latitude": "32.5683326",
      "poi_longitude": "-97.1369698",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2fwdAdhToYRbPyQKCTZjwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7323e59a085489e5d804904f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Town Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 N Main St, Mansfield, TX 76063, USA",
      "poi_short_description": "Green space with a 600-seat amphitheater plus playgrounds, picnic areas, trails & sports courts.",
      "poi_long_description": "Green space with a 600-seat amphitheater plus playgrounds, picnic areas, trails & sports courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-ba0a-726a-8182-273d339dab63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ba0a-726a-8182-273d339dab63",
        "storage_key": "property/5677123549265920/019f1508-ba0a-726a-8182-273d339dab63.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1105/Town-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12350979839875521573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-park",
      "poi_latitude": "32.571591",
      "poi_longitude": "-97.1429378",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxUM5AVhToYRJZzK37l-Z6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2ed52d70158a272bafdfa2a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "James McKnight Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 U.S. 287 Frontage Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Treed park featuring 4 lighted softball fields, a playground & picnic spots, plus many pavilions.",
      "poi_long_description": "Treed park featuring 4 lighted softball fields, a playground & picnic spots, plus many pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-ba7e-77b6-944b-6fdbc646bc46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ba7e-77b6-944b-6fdbc646bc46",
        "storage_key": "property/5677123549265920/019f1508-ba7e-77b6-944b-6fdbc646bc46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1092/James-McKnight-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9699130634700180185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-mcknight-park",
      "poi_latitude": "32.573719",
      "poi_longitude": "-97.1204985",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc3lNJrphToYR2cppj-w7moY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_688dd57bcd5ff628cb1a3f6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Philip Thompson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Holland Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Eight-acre complex featuring irrigated fields for use by teams, plus two lit game fields.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-ba0e-761b-8a21-f0c2f8ea514a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ba0e-761b-8a21-f0c2f8ea514a",
        "storage_key": "property/5677123549265920/019f1508-ba0e-761b-8a21-f0c2f8ea514a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1101/Philip-Thompson-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3205447463296697777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philip-thompson-park",
      "poi_latitude": "32.5856754",
      "poi_longitude": "-97.0841217",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyap1XKKToYRsQX6E3wJfCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_4fcd1147435439991e876431",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mans Best Field Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "610 W Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "Clean dog park featuring 2 areas for large pups, 2 for small ones and water fountains.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-c48f-742b-bfc7-85fbdaa369f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c48f-742b-bfc7-85fbdaa369f4",
        "storage_key": "property/5677123549265920/019f1508-c48f-742b-bfc7-85fbdaa369f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1509/Mans-Best-Field-Dog-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12761620624496625770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mans-best-field-dog-park",
      "poi_latitude": "32.564327",
      "poi_longitude": "-97.148683",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7zoKdTNhToYRaohrEVhiGrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_509cd8ede7c0147f129570c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Pond Branch Linear Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "199 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-cdeb-7032-9b73-77b1712c81a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-cdeb-7032-9b73-77b1712c81a9",
        "storage_key": "property/5677123549265920/019f1508-cdeb-7032-9b73-77b1712c81a9.webp",
        "width": 1280,
        "height": 1075
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1089/Pond-Branch-Linear-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5745431027788335975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pond-branch-linear-park",
      "poi_latitude": "32.5632916",
      "poi_longitude": "-97.1409074",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0YwggFhToYRZ8vURBTfu08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6777854e326e6b8a58c94181",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Britton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "829 Seeton Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Tranquil park area featuring a 2-lane boat ramp & a fishing bank, plus restrooms & parking.",
      "poi_long_description": "Tranquil park area featuring a 2-lane boat ramp & a fishing bank, plus restrooms & parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-b8cf-76c6-9e09-41b3697bc3df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b8cf-76c6-9e09-41b3697bc3df",
        "storage_key": "property/5677123549265920/019f1508-b8cf-76c6-9e09-41b3697bc3df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://grandfungp.com/britton-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14317172648566812766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "britton-park",
      "poi_latitude": "32.5489065",
      "poi_longitude": "-97.0547505",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-237-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm57eZOSKToYRXnDDEavQsMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9af914ef130e50f1833fbaa2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Killian Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "901 Killian Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-c17c-769d-ae1a-c661b0e7a5a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c17c-769d-ae1a-c661b0e7a5a0",
        "storage_key": "property/5677123549265920/019f1508-c17c-769d-ae1a-c661b0e7a5a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/1096/Killian-Park-at-Woodland-Estates",
      "poi_directions_map_url": "https://maps.google.com/?cid=5951480247231684941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "killian-park",
      "poi_latitude": "32.6019314",
      "poi_longitude": "-97.1569458",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-728-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d65-70de-bf42-d0beb2451afa",
        "storage_key": "property/5677123549265920/019f1506-9d65-70de-bf42-d0beb2451afa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxV5Ml5hToYRTaH_p8Dnl1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0a6ce01f19f6aae95d7eece1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "DFW Airport Headquarters",
      "poi_type": "Transportation & Transit",
      "poi_address": "DFW Airport Headquarters, 2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-c4a7-77f7-8f8b-479c82ba065a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c4a7-77f7-8f8b-479c82ba065a",
        "storage_key": "property/5677123549265920/019f1508-c4a7-77f7-8f8b-479c82ba065a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dfwairport.com/business/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15718075392826170593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-headquarters",
      "poi_latitude": "32.8558009",
      "poi_longitude": "-97.0378457",
      "poi_miles_from_property": "23.6 mi",
      "poi_walking_minutes": "8 hours 43 mins",
      "poi_biking_minutes": "2 hours 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 972-973-4644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7KqRR-ZToYR4Vw2tkrSIdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_b157ecded1b837a93ed90116",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "DFW Airport Terminal B",
      "poi_type": "Transportation & Transit",
      "poi_address": "Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-d956-71f9-a1ba-cfcb7d80f591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d956-71f9-a1ba-cfcb7d80f591",
        "storage_key": "property/5677123549265920/019f1508-d956-71f9-a1ba-cfcb7d80f591.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542362866335770885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-terminal-b",
      "poi_latitude": "32.9062404",
      "poi_longitude": "-97.0412791",
      "poi_miles_from_property": "27.5 mi",
      "poi_walking_minutes": "10 hours 9 mins",
      "poi_biking_minutes": "2 hours 47 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpectJlwqTIYRBWnyYBX-cvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_30b7bf56d9d76bea9188b05a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "DFW Airport North TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1867 E Dallas Rd, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-d96b-76df-b78a-f0e8b0f869c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d96b-76df-b78a-f0e8b0f869c2",
        "storage_key": "property/5677123549265920/019f1508-d96b-76df-b78a-f0e8b0f869c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/dfw-airport-north-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6621859291758648515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-north-texrail-station",
      "poi_latitude": "32.9337128",
      "poi_longitude": "-97.0541165",
      "poi_miles_from_property": "29.4 mi",
      "poi_walking_minutes": "11 hours 0 mins",
      "poi_biking_minutes": "3 hours 3 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOV8hQtwrTIYRw9zkFfGR5Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ea1dec5f0f394da2c905bf6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-ecc4-70b5-a152-ca2606acbaea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ecc4-70b5-a152-ca2606acbaea",
        "storage_key": "property/5677123549265920/019f1508-ecc4-70b5-a152-ca2606acbaea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "21.3 mi",
      "poi_walking_minutes": "7 hours 52 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2076-70bf-9429-37e4dc11a44e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2076-70bf-9429-37e4dc11a44e",
        "storage_key": "property/5677123549265920/019f1509-2076-70bf-9429-37e4dc11a44e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_dfad616f67c48b5a44a2f5b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Grapevine/Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-e63f-77f8-adda-fdbebfef9351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e63f-77f8-adda-fdbebfef9351",
        "storage_key": "property/5677123549265920/019f1508-e63f-77f8-adda-fdbebfef9351.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18405502107178557258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevinemain-street-station",
      "poi_latitude": "32.9338028",
      "poi_longitude": "-97.0772663",
      "poi_miles_from_property": "28.1 mi",
      "poi_walking_minutes": "10 hours 31 mins",
      "poi_biking_minutes": "2 hours 57 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz-M8e0rTIYRSt8UY6Z6bf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_e4e3c742c3877828b40a982b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Bell Flight Blvd, Hurst, TX 76053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-eb65-711f-b48b-d9a300ae0364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-eb65-711f-b48b-d9a300ae0364",
        "storage_key": "property/5677123549265920/019f1508-eb65-711f-b48b-d9a300ae0364.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trinityrailwayexpress.org/station/bell-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11367673502258708933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8046324",
      "poi_longitude": "-97.1551139",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 15 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2056-735c-a573-e58e5615582a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2056-735c-a573-e58e5615582a",
        "storage_key": "property/5677123549265920/019f1509-2056-735c-a573-e58e5615582a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSKsN5V-ToYRxUHAYNIWwp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_f9196bf277087a34fefeef0d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-e5e0-705f-a608-4bd92619a0ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e5e0-705f-a608-4bd92619a0ed",
        "storage_key": "property/5677123549265920/019f1508-e5e0-705f-a608-4bd92619a0ed.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "8 hours 18 mins",
      "poi_biking_minutes": "2 hours 10 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2056-735c-a573-e58e5615582a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2056-735c-a573-e58e5615582a",
        "storage_key": "property/5677123549265920/019f1509-2056-735c-a573-e58e5615582a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_3545eb26ad4da26b2715431b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "South Park and Ride -Trinity Metro",
      "poi_type": "Transportation & Transit",
      "poi_address": "351 E Alsbury Blvd, Burleson, TX 76028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6731593781910445394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-park-and-ride--trinity-metro",
      "poi_latitude": "32.563541",
      "poi_longitude": "-97.3148174",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 26 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2076-70bf-9429-37e4dc11a44e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2076-70bf-9429-37e4dc11a44e",
        "storage_key": "property/5677123549265920/019f1509-2076-70bf-9429-37e4dc11a44e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJofzhaxtpToYRUh0AD-Fsa10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_bec17715ffa40e927a63a744",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Fairfield by Marriott Inn & Suites Dallas Mansfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "1480 U.S. 287 Frontage Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "Laid-back hotel offering unfussy rooms & suites, plus an indoor pool & free hot breakfast.",
      "poi_long_description": "Laid-back hotel offering unfussy rooms & suites, plus an indoor pool & free hot breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-da6b-7198-b3cf-06b722be4c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-da6b-7198-b3cf-06b722be4c6a",
        "storage_key": "property/5677123549265920/019f1508-da6b-7198-b3cf-06b722be4c6a.webp",
        "width": 569,
        "height": 320
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/dalfm-fairfield-inn-and-suites-dallas-mansfield/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0",
      "poi_directions_map_url": "https://maps.google.com/?cid=16770259604591891209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairfield-by-marriott-inn--suites-dallas-mansfield",
      "poi_latitude": "32.5866311",
      "poi_longitude": "-97.1367346",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-473-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-2058-710b-b163-386a273541d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-2058-710b-b163-386a273541d2",
        "storage_key": "property/5677123549265920/019f1509-2058-710b-b163-386a273541d2.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJUTxZbj1gToYRCVPI-kHuu-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "ec_aa146a3c091dc7706ada33aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mouser Electronics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 N Main St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-f2c2-7532-a9ac-343b22a32bd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-f2c2-7532-a9ac-343b22a32bd8",
        "storage_key": "property/5677123549265920/019f1508-f2c2-7532-a9ac-343b22a32bd8.webp",
        "width": 1280,
        "height": 675
      },
      "poi_business_url": "https://www.mouser.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16643372301741946795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mouser-electronics",
      "poi_latitude": "32.5786915",
      "poi_longitude": "-97.1479123",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-346-6873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2UOSRJhToYRq3fnle0i-eY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_abe3dbfbd4cd2b66e4e6f6eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Methodist Mansfield Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2700 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-85aa-76bf-acf4-a7da0138de15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-85aa-76bf-acf4-a7da0138de15",
        "storage_key": "property/5677123549265920/019f1506-85aa-76bf-acf4-a7da0138de15.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.methodisthealthsystem.org/methodist-mansfield-medical-center/?L=true",
      "poi_directions_map_url": "https://maps.google.com/?cid=14677445230321326988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-mansfield-medical-center",
      "poi_latitude": "32.5680233",
      "poi_longitude": "-97.0945881",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 682-242-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3c-740d-92c1-6c4d64a18d3f",
        "storage_key": "property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48CMNNRhToYRjNuNK6zCsMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_130077b833d3281e929f36c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Texas Health Hospital Mansfield",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2300 Lone Star Rd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-8c2c-7178-ae0d-831be2cb2890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-8c2c-7178-ae0d-831be2cb2890",
        "storage_key": "property/5677123549265920/019f1506-8c2c-7178-ae0d-831be2cb2890.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.texashealthmansfield.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6266422286248126131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-hospital-mansfield",
      "poi_latitude": "32.5370605",
      "poi_longitude": "-97.0996562",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 682-341-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3c-740d-92c1-6c4d64a18d3f",
        "storage_key": "property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZY-2MWBhToYRsyZpUN7N9lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_3d1995146263c041cabc1edd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Klein Tools, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Klein Tools Blvd, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-f1f7-7309-9a83-ec739c225608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-f1f7-7309-9a83-ec739c225608",
        "storage_key": "property/5677123549265920/019f1508-f1f7-7309-9a83-ec739c225608.webp",
        "width": 800,
        "height": 537
      },
      "poi_business_url": "https://www.kleintools.com/?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=277236253255999532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klein-tools-inc",
      "poi_latitude": "32.5445155",
      "poi_longitude": "-97.143387",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-477-8450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wXAp_FgToYRLCAvSufw2AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_3f2208079121d2b7eca37946",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mansfield Independent School District Administration Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "605 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-fe0f-709e-936f-b687de0cb2a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-fe0f-709e-936f-b687de0cb2a6",
        "storage_key": "property/5677123549265920/019f1508-fe0f-709e-936f-b687de0cb2a6.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.mansfieldisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14786994468414565956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-independent-school-district-administration-office",
      "poi_latitude": "32.5650733",
      "poi_longitude": "-97.1363292",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-299-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d59-71ed-9791-558ee27fd5b6",
        "storage_key": "property/5677123549265920/019f1506-9d59-71ed-9791-558ee27fd5b6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKaX8mwBhToYRRC6EyR_1Nc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a3556c53dc13d7af026841b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Mansfield City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E Broad St, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-08a1-714f-8e42-7aee97f00547.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-08a1-714f-8e42-7aee97f00547",
        "storage_key": "property/5677123549265920/019f1509-08a1-714f-8e42-7aee97f00547.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.mansfieldtexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7899478819566267862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-city-hall",
      "poi_latitude": "32.5651331",
      "poi_longitude": "-97.1253934",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-20df-75e9-bb41-2c002d775c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-20df-75e9-bb41-2c002d775c38",
        "storage_key": "property/5677123549265920/019f1509-20df-75e9-bb41-2c002d775c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzp8ebJhToYR1i34FiKWoG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_e8959a1fe82a90674029749f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Utex Industries, Inc. - Mansfield",
      "poi_type": "Major Employers & Offices",
      "poi_address": "102 Sentry Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-043e-7058-92d0-0614099659f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-043e-7058-92d0-0614099659f9",
        "storage_key": "property/5677123549265920/019f1509-043e-7058-92d0-0614099659f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utexind.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16819076486558684355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utex-industries-inc---mansfield",
      "poi_latitude": "32.551071",
      "poi_longitude": "-97.1345941",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-225-1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwIDJfdhToYRw5R0B_Rcaek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_86ce7dc4301470fa2201a085",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Universal Air Conditioner",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1441 Heritage Pkwy, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1508-fe5c-7652-a8e8-5e987a990419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-fe5c-7652-a8e8-5e987a990419",
        "storage_key": "property/5677123549265920/019f1508-fe5c-7652-a8e8-5e987a990419.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uacparts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18133477754830533876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "universal-air-conditioner",
      "poi_latitude": "32.5538249",
      "poi_longitude": "-97.1245891",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-740-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJARB14E5gToYR9DQfV_ENp_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "ec_0a3d7d3771667bf88333ab0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Hoffman Cabinets Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "204 Sentry Dr, Mansfield, TX 76063, USA",
      "poi_short_description": "Company fabricating and installing cabinets in new builds and model homes, plus offering hardware.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-0c02-7179-966f-7d8b776fe365.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-0c02-7179-966f-7d8b776fe365",
        "storage_key": "property/5677123549265920/019f1509-0c02-7179-966f-7d8b776fe365.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hoffmancabinets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16247701753578388470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hoffman-cabinets-inc",
      "poi_latitude": "32.5493011",
      "poi_longitude": "-97.1379394",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-473-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d72-718d-a1d7-c88d00bba470",
        "storage_key": "property/5677123549265920/019f1506-9d72-718d-a1d7-c88d00bba470.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyIDgPdgToYR9vuHLqlue-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_d78c4779003a48c78c47c5c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "poi_name": "Baylor Scott & White Emergency Hospitals - Mansfield",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1776 U.S. 287 Frontage Rd Ste 100, Mansfield, TX 76063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1509-1059-72bb-8a4b-473ce7962257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1059-72bb-8a4b-473ce7962257",
        "storage_key": "property/5677123549265920/019f1509-1059-72bb-8a4b-473ce7962257.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bsweh.org/locations/mansfield?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16474109992139841929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-emergency-hospitals---mansfield",
      "poi_latitude": "32.5969292",
      "poi_longitude": "-97.1449511",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-294-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-9d3c-740d-92c1-6c4d64a18d3f",
        "storage_key": "property/5677123549265920/019f1506-9d3c-740d-92c1-6c4d64a18d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_xW4nphToYRiWE1GMHLn-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_49a06140-ca6d-4a7d-ab15-125f85430ca9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9566af27-636d-4d6e-a4b8-177e27ca916a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_445546a6-326b-4aa8-97b6-697e88f06e5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_ebf9db44-5767-4160-858a-c7e102a04441",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_66d6ab72-8a13-4f81-bbf1-080fa8b318a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_c352f860-ca82-4c58-8dab-55ff75b8cc80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_5ef4713c-9800-4f3a-8fda-aa731e8e1e01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "rating": "5.0",
      "name": "Ky Nguyen",
      "text": "I lived here for 2 years, and I can say the Evolv is better than my previous so-called luxury apartment, the Audrey. I moved out of the Audrey before coming here because of the rude assistant manager, unreasonable move-out charges, thin walls/ceiling that you hear everything your neighbors do, and rent went up $150 every year.\nPros at the Evolv: more affordable rent compared to other apartments in the area, friendly management, quiet and nice neighbors, super efficient maintenance team, not as strict as other luxury apartments, great walking area within the apartments, plenty of trees and grass, spacious floor plans, modest annual rent increase. There are not so many cons and if there is, it’s minor. Thank you, Evolv team, for making it easy!",
      "date": "2025-01-22",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_101c0096f5889c9ed2260c9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019d02f0-da23-756e-9ade-3af0cac6a8a9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Stylish living room with grey sofa, coffee table, and modern art.",
        "public_id": "019d02f0-da23-756e-9ade-3af0cac6a8a9",
        "storage_key": "property/5677123549265920/019d02f0-da23-756e-9ade-3af0cac6a8a9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1B/1BA - 750sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=p6Wh8oCup6T"
    },
    {
      "id": "ec_aa5d06d1b53cb6175785788d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f14c4-3125-7768-bfff-3059f83ac518.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-3125-7768-bfff-3059f83ac518",
        "storage_key": "property/5677123549265920/019f14c4-3125-7768-bfff-3059f83ac518.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Evolv",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/o3YWIaRSsaI"
    },
    {
      "id": "ec_d2839ee9bda6d1b46c4df3b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f14c4-2cdb-72ac-9220-ce160f3bf517.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-2cdb-72ac-9220-ce160f3bf517",
        "storage_key": "property/5677123549265920/019f14c4-2cdb-72ac-9220-ce160f3bf517.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jak2f3D8X7j"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-80fb-751c-91c5-35bcead411ce",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "evolv",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920"
    },
    {
      "lead_collector_id": "0198aa45-815e-734b-8d17-639a33bfe158",
      "lead_source": "FACEBOOK_ADS",
      "name": "evolv",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920"
    },
    {
      "lead_collector_id": "0198aa45-81c0-72ff-9920-6bdab93b323a",
      "lead_source": "LANDING_PAGE",
      "name": "evolv",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-mansfield-tx",
      "search_query": "One Bedroom Apartments For Rent In Mansfield TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent in Mansfield, TX",
      "h2_subtitle": "Evolv offers beautifully designed one-bedroom apartments with modern amenities. Enjoy a vibrant community with a resort-style pool and fitness center.",
      "page_copy": "Evolv presents an exceptional living experience with one bedroom apartments for rent in Mansfield, TX. Our homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring comfort and style. Natural light fills each apartment, creating a warm and inviting atmosphere. Residents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. \n\nLocated in Mansfield, Evolv is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our one-bedroom apartments for rent in Mansfield, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | One Bedroom Apartments For Rent in Mansfield, TX",
      "seo_description": "Explore Evolv's one bedroom apartments for rent in Mansfield, TX. Enjoy modern amenities and a vibrant community with a pool and fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-mansfield-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Mansfield TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedroom Apartments For Rent in Mansfield, TX",
      "h2_subtitle": "Evolv offers spacious two-bedroom apartments with modern amenities. Enjoy a vibrant community with a resort-style pool and fitness center.",
      "page_copy": "Evolv invites you to discover our two bedroom apartments for rent in Mansfield, TX, where comfort meets style. Each apartment features tile and carpet floors, stainless steel appliances, and walk-in closets, providing a perfect blend of functionality and elegance. Natural light enhances the living spaces, creating a welcoming environment for you and your family. \n\nOur community amenities include a luxurious resort-style swimming pool, a clubhouse with billiards, and a state-of-the-art fitness center, ensuring there's always something to enjoy. Located in the heart of Mansfield, Evolv is close to delightful dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the ideal place to call home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our two-bedroom apartments for rent in Mansfield, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Two Bedrooms Apartments For Rent in Mansfield, TX",
      "seo_description": "Discover Evolv's two bedroom apartments for rent in Mansfield, TX. Enjoy modern amenities and a vibrant community with a pool and fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-three-bedrooms-apartments-for-rent-mansfield-tx",
      "search_query": "Three Bedrooms Apartments For Rent In Mansfield TX",
      "category": "Floorplan",
      "h1_title": "Find Three Bedroom Apartments For Rent in Mansfield, TX",
      "h2_subtitle": "Evolv offers expansive three-bedroom apartments with premium amenities. Enjoy a vibrant community with a resort-style pool and fitness center.",
      "page_copy": "Discover the perfect family home with our three bedroom apartments for rent in Mansfield, TX at Evolv. These spacious apartments feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a comfortable and stylish living experience. Abundant natural light fills each room, creating a warm and inviting atmosphere for you and your loved ones. \n\nEvolv's community amenities include a luxurious resort-style swimming pool, a clubhouse with billiards, and a modern fitness center, providing endless opportunities for relaxation and recreation. Situated in Mansfield, our location offers easy access to local dining favorites like Our Place Restaurant and Fish City Grill, as well as shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the ideal place to call home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our three-bedroom apartments for rent in Mansfield, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Three Bedroom Apartments For Rent in Mansfield, TX",
      "seo_description": "Explore Evolv's three bedroom apartments for rent in Mansfield, TX. Enjoy modern amenities and a vibrant community with a pool and fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Pool at Evolv",
      "h2_subtitle": "Evolv offers modern apartments with a luxurious resort-style pool. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent with a pool, offering a perfect blend of comfort and convenience. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located in Mansfield, Evolv is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent with a pool.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore Evolv's apartments for rent with a pool. Enjoy modern amenities and a vibrant community with a luxurious resort-style pool.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near You with a Fitness Center at Evolv",
      "h2_subtitle": "Evolv offers modern apartments with a state-of-the-art fitness center. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv provides an exceptional living experience with apartments for rent with a fitness center, combining comfort and convenience in a vibrant community. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light enhances each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a variety of community amenities, including a state-of-the-art fitness center, a luxurious resort-style swimming pool, and a clubhouse with billiards. Located in Mansfield, Evolv is close to delightful dining options like Our Place Restaurant and Fish City Grill, as well as shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent with a fitness center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore Evolv's apartments for rent with a fitness center. Enjoy modern amenities and a vibrant community with a state-of-the-art fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-clubhouse",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Clubhouse at Evolv",
      "h2_subtitle": "Evolv offers modern apartments with a welcoming clubhouse. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent with a clubhouse, offering a perfect blend of comfort and community. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a welcoming clubhouse perfect for lounging or playing billiards, a luxurious resort-style swimming pool, and a fully equipped fitness center. Located in Mansfield, Evolv is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent with a clubhouse.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Explore Evolv's apartments for rent with a clubhouse. Enjoy modern amenities and a vibrant community with a welcoming clubhouse.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-pet-play-area",
      "search_query": "Apartments For Rent Near Me with Pet Play Area",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near You with a Pet Play Area at Evolv",
      "h2_subtitle": "Evolv offers pet-friendly apartments with a dedicated pet play area. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv welcomes you to a pet-friendly community with apartments for rent with a pet play area, where both you and your furry friends can feel at home. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a comfortable and stylish living space. Natural light enhances each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a variety of community amenities, including a dedicated pet play area, a luxurious resort-style swimming pool, and a clubhouse with billiards. Located in Mansfield, Evolv is close to delightful dining options like Our Place Restaurant and Fish City Grill, as well as shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent with a pet play area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments For Rent Near Me with Pet Play Area",
      "seo_description": "Discover Evolv's apartments for rent with a pet play area. Enjoy modern amenities and a vibrant community with a dedicated pet play area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-granite",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near You with Granite Countertops at Evolv",
      "h2_subtitle": "Evolv offers modern apartments with elegant granite countertops. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent with granite countertops, offering a perfect blend of style and functionality. Our beautifully designed homes feature kitchens with elegant granite countertops, stainless steel appliances, and ample storage space, ensuring a delightful cooking experience. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located in Mansfield, Evolv is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and high ceilings. Visit us today to explore our apartments for rent with granite countertops.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Discover Evolv's apartments for rent with granite countertops. Enjoy modern amenities and a vibrant community with elegant kitchen features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with Stainless Steel Appliances at Evolv",
      "h2_subtitle": "Evolv offers modern apartments with sleek stainless steel appliances. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent with stainless steel appliances, offering a perfect blend of style and functionality. Our beautifully designed homes feature kitchens equipped with sleek stainless steel appliances, granite countertops, and ample storage space, ensuring a delightful cooking experience. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located in Mansfield, Evolv is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and high ceilings. Visit us today to explore our apartments for rent with stainless steel appliances.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments Near Me with Stainless Steel Appliances",
      "seo_description": "Explore Evolv's apartments for rent with stainless steel appliances. Enjoy modern amenities and a vibrant community with sleek kitchen features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-pantry",
      "search_query": "Apartments For Rent Near Me with Pantry",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near You with a Pantry at Evolv",
      "h2_subtitle": "Evolv offers modern apartments with convenient pantry space. Enjoy a vibrant community with exceptional amenities and convenient local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent with a pantry, offering a perfect blend of style and functionality. Our beautifully designed homes feature kitchens with convenient pantry space, stainless steel appliances, and granite countertops, ensuring a delightful cooking experience. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located in Mansfield, Evolv is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and high ceilings. Visit us today to explore our apartments for rent with a pantry.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments For Rent Near Me with Pantry",
      "seo_description": "Discover Evolv's apartments for rent with a pantry. Enjoy modern amenities and a vibrant community with convenient kitchen storage.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-mansfield-tx-near-methodist",
      "search_query": "Apartments For Rent In Mansfield TX Near Methodist Mansfield Medical Center",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Mansfield, TX Near Methodist Mansfield Medical Center",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near Methodist Mansfield Medical Center. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Methodist Mansfield Medical Center, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near the award-winning Methodist Mansfield Medical Center, Evolv provides easy access to quality healthcare services. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Methodist Mansfield Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments Near Methodist Mansfield Medical Center",
      "seo_description": "Discover Evolv's apartments for rent in Mansfield, TX near Methodist Mansfield Medical Center. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-mansfield-tx-near-usmd-hospital",
      "search_query": "Apartments For Rent In Mansfield TX Near USMD Hospital at Arlington",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Mansfield, TX Near USMD Hospital at Arlington",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near USMD Hospital at Arlington. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near USMD Hospital at Arlington, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near USMD Hospital at Arlington, Evolv provides easy access to top-notch healthcare services, including advanced surgical specialties and emergency care. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield TX near USMD Hospital at Arlington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments in Mansfield Near USMD Hospital",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near USMD Hospital at Arlington. Enjoy top amenities and a vibrant community close to quality healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-mansfield-tx-near-medical-city",
      "search_query": "Apartments For Rent In Mansfield TX Near Medical City Arlington",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Mansfield, TX Near Medical City Arlington",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near Medical City Arlington. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Medical City Arlington, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near Medical City Arlington, Evolv provides easy access to comprehensive medical services, including specialized cardiovascular and women's programs. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Medical City Arlington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments in Mansfield Near Medical City Arlington",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near Medical City Arlington. Enjoy top amenities and a vibrant community close to comprehensive healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-mansfield-tx-near-dbu",
      "search_query": "Apartments For Rent In Mansfield TX Near Dallas Baptist University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Mansfield, TX Near Dallas Baptist University",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near Dallas Baptist University. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Dallas Baptist University, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near Dallas Baptist University, Evolv provides easy access to educational opportunities and campus activities. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Dallas Baptist University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments Near Dallas Baptist University",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near Dallas Baptist University. Enjoy modern amenities and a vibrant community today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-mansfield-tx-near-uta",
      "search_query": "Apartments For Rent In Mansfield TX Near The University of Texas at Arlington",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Mansfield, TX Near The University of Texas at Arlington",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near The University of Texas at Arlington. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near The University of Texas at Arlington, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near The University of Texas at Arlington, Evolv provides easy access to educational opportunities and campus activities. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near The University of Texas at Arlington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments Near The University of Texas at Arlington",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near The University of Texas at Arlington. Enjoy modern amenities and a vibrant community today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-mansfield-tx-near-uta",
      "search_query": "Apartments For Rent In Mansfield TX Near University of Texas Arlington",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Mansfield, TX Near University of Texas Arlington",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near University of Texas Arlington. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near University of Texas Arlington, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near University of Texas Arlington, Evolv provides easy access to educational opportunities and campus activities. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near University of Texas Arlington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments Near University of Texas Arlington",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near University of Texas Arlington. Enjoy modern amenities and a vibrant community today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-mansfield-tx",
      "search_query": "Apartments For Rent In Mansfield TX Near Tarrant County College - South Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Mansfield, TX Near Tarrant County College",
      "h2_subtitle": "Evolv offers modern apartments conveniently located near Tarrant County College. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Tarrant County College, offering a perfect blend of convenience and comfort. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nResidents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. Located near Tarrant County College - South Campus, Evolv provides easy access to quality education and training programs. Additionally, the community is surrounded by excellent dining options like Our Place Restaurant and Fish City Grill, as well as convenient shopping at Big Lots, Walgreens, and PetSmart. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Tarrant County College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments in Mansfield Near Tarrant County College",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near Tarrant County College. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-mansfield-tx-near-danny-jones",
      "search_query": "Apartments For Rent In Mansfield TX Near Danny Jones Middle School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Mansfield, TX Near Danny Jones Middle School",
      "h2_subtitle": "Evolv offers family-friendly apartments conveniently located near Danny Jones Middle School. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Danny Jones Middle School, perfect for families seeking quality education within the Mansfield Independent School District. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nLocated just 3.0 km from Danny Jones Middle School, Evolv provides easy access to this esteemed public school, making it an excellent choice for families with children in seventh and eighth grades. Residents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Danny Jones Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments Near Danny Jones Middle School",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near Danny Jones Middle School. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-mansfield-tx-near-lake-ridge-high",
      "search_query": "Apartments For Rent In Mansfield TX Near Lake Ridge High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Mansfield, TX Near Lake Ridge High School",
      "h2_subtitle": "Evolv offers family-friendly apartments conveniently located near Lake Ridge High School. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Lake Ridge High School, perfect for families seeking quality education within the Mansfield Independent School District. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nLocated just 4.9 km from Lake Ridge High School, Evolv provides easy access to this esteemed public school, making it an excellent choice for families. Residents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Lake Ridge High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments in Mansfield Near Lake Ridge High School",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near Lake Ridge High School. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5677123549265920",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-mansfield-tx-near-high-school",
      "search_query": "Apartments For Rent In Mansfield TX Near Mansfield High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Mansfield, TX Near Mansfield High School",
      "h2_subtitle": "Evolv offers family-friendly apartments conveniently located near Mansfield High School. Enjoy a vibrant community with exceptional amenities and local attractions.",
      "page_copy": "Evolv presents an ideal living experience with apartments for rent in Mansfield, TX near Mansfield High School, perfect for families seeking quality education within the Mansfield Independent School District. Our beautifully designed homes feature tile and carpet floors, stainless steel appliances, and walk-in closets, ensuring a stylish and functional living space. Natural light fills each apartment, creating a warm and inviting atmosphere. \n\nLocated just 2.5 km from Mansfield High School, Evolv provides easy access to this esteemed public school, making it an excellent choice for families. Residents can enjoy a range of community amenities, including a luxurious resort-style swimming pool, a clubhouse with billiards, and a fully equipped fitness center. With floor plans that include one, two, or three bedrooms, Evolv is the perfect place to find your ideal home. Experience the best of apartment living with features like Wi-Fi, air conditioning, and granite countertops. Visit us today to explore our apartments for rent in Mansfield, TX near Mansfield High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs, umbrellas, cabanas, and seating areas at a multifamily property.",
        "public_id": "019f6c0e-cd88-734e-bbc0-80fa61755424",
        "storage_key": "property/5677123549265920/019f6c0e-cd88-734e-bbc0-80fa61755424.webp",
        "width": 1920,
        "height": 1079
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0e-d772-752a-ab27-c7187fe706b1",
        "storage_key": "property/5677123549265920/019f6c0e-d772-752a-ab27-c7187fe706b1.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Evolv | Apartments in Mansfield Near Mansfield High School",
      "seo_description": "Explore Evolv's apartments for rent in Mansfield, TX near Mansfield High School. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2160"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471093"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4349312"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5LZ5Z37"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://evolv.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443846699"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8ywko93gvlx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/3ef19c85-f8c4-43f9-a553-b4a3ab269456"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-587-4978"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImdaVlVxR2c1L20wdTdwSm5sRDJreEE9PSIsInZhbHVlIjoiMlBSbTdHVldwUzI4OTQ3cHZVUXVsQT09IiwibWFjIjoiNTliMDllZTQxYzk5OGFmNmJhNGFjNjVhNTVhYjQ2M2UxZmVjODcwMjY2NTFhMmYyMjMzYzUwOWZmOGJhNTQ4NiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2160",
  "custom_repli_id": "2376471093",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4349312",
  "custom_google_gtm_id": "GTM-5LZ5Z37",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://evolv.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443846699",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8ywko93gvlx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/3ef19c85-f8c4-43f9-a553-b4a3ab269456",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-587-4978",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImdaVlVxR2c1L20wdTdwSm5sRDJreEE9PSIsInZhbHVlIjoiMlBSbTdHVldwUzI4OTQ3cHZVUXVsQT09IiwibWFjIjoiNTliMDllZTQxYzk5OGFmNmJhNGFjNjVhNTVhYjQ2M2UxZmVjODcwMjY2NTFhMmYyMjMzYzUwOWZmOGJhNTQ4NiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "12cd1d4c-7d4c-4352-9cc8-4ca64b4aa262",
  "custom_audioeye_site_hash": "abd5e33e93e4cf1d3475c1880e89d7a8"
};

export const generatedAt = '2026-11-03T20:35:52.058Z';
